import { debugLog } from "./utils/debugLog.js";
// import statements----------------------------------------------------------------------------------
import React, { Fragment, useEffect, useState, useRef, useContext } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import Select from "react-select";
import Fuse from "fuse.js";
import Creatable from "react-select/creatable";
import AutomationUpgrade from "./AutomationUpgrade.js";
import { Switch, RadioGroup } from "@headlessui/react";
import Airtable from "airtable";
import {
	CheckBadgeIcon,
	TrashIcon,
	ArrowUpCircleIcon,
	Cog6ToothIcon,
	ArrowsRightLeftIcon,
	ArrowUpIcon,
	GiftIcon,
	LockClosedIcon,
	LinkedInIcon,
	LinkIcon
} from "@heroicons/react/20/solid";
import { Accordion, AccordionHeader, AccordionBody, Tooltip, Label } from "@material-tailwind/react";
import { classNames, extractDomain, setContents, setShowNotif } from "./helpers.js";
import { automationPartners } from "./helperData.js";
import { useUser } from "@clerk/clerk-react";
import Notification from "./Notification.js";
import Skeleton from "react-loading-skeleton";
import AutomationContext from "./AutomationContext.js";
import { PlusCircleIcon, CheckIcon, PencilIcon } from "@heroicons/react/24/outline";
import { MagnifyingGlassIcon, SparklesIcon } from '@heroicons/react/24/outline';
import AutomationDirectory from './components/AutomationDirectory.jsx';

// defining global variables/functions
const apiKey = process.env.REACT_APP_AIR_KEY;
const baseId = process.env.REACT_APP_AIR_BASEID;
const peopleTable = process.env.REACT_APP_AIR_PEOPLE;
const companyTable = process.env.REACT_APP_AIR_COMPANIES;
const base2 = new Airtable({ apiKey }).base(baseId);
const clayApiKey = "80bf797298733a979683";

function Icon({ id, open }) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className={`${open ? "rotate-180" : ""} h-6 w-6 transition-transform`}
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			strokeWidth={2}
		>
			<path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
		</svg>
	);
}

export default function Automation({ company, getQueryVariable, grantWriters, fullBlur, hideTabBar = false, forceTab = null }) {
	// ALL STATES GO HERE----------------------------------------------------------------------------------
	const navigate = useNavigate();
	const location = useLocation();
	const { automationPeople, setAutomationPeople } = useContext(AutomationContext);
	// resp to automation object (nested inside each person, for caching purposes)
	const [biggerAutomationMap, setBiggerAutomationMap] = useState({});

	const [dataReady, setDataReady] = useState(false);

	// loading for initial render
	const [loading, setLoading] = useState(true);

	// so that we know when to pull default people from airtable
	// const [deleteNow, setDeleteNow] = useState(false);

	// for getting the most up to date company
	const [curCompany, setCurCompany] = useState(company);

	// stores the titles
	const [titles, setTitles] = useState([]);

	// current responsibilities of person selected
	const [newResponsibilities, setNewResponsibilities] = useState([]);

	// hours
	const [inputData, setInputData] = useState({
		0: "4",
		1: "2",
		2: "2",
		3: "2",
		4: "2",
		5: "2",
		6: "2",
		7: "2",
		8: "2",
		9: "2",
		10: "2",
		11: "2",
		12: "2",
		13: "2",
		14: "2",
		15: "2",
		16: "2",
		17: "2",
		18: "2",
		19: "2",
	});

	// switches
	const [toggleData, setToggleData] = useState({
		0: { id: 0, value: false },
		1: { id: 1, value: false },
		2: { id: 2, value: false },
		3: { id: 3, value: false },
		4: { id: 4, value: false },
		5: { id: 5, value: false },
		6: { id: 6, value: false },
		7: { id: 7, value: false },
		8: { id: 8, value: false },
		9: { id: 9, value: false },
		10: { id: 10, value: false },
		11: { id: 11, value: false },
		12: { id: 12, value: false },
		13: { id: 13, value: false },
		14: { id: 14, value: false },
		15: { id: 15, value: false },
		16: { id: 16, value: false },
		17: { id: 17, value: false },
		18: { id: 18, value: false },
		19: { id: 19, value: false },
	});

	// selected person's title
	const [selectedOption, setSelectedOption] = useState({ value: "Sales Director", label: "Sales Director" });

	// selected person's salary
	const [selectedSalary, setSelectedSalary] = useState({ value: 100000, label: currencyFormat(100000) });

	// NEW DATA
	const [selectedSoftware, setSelectedSoftware] = useState([]);
	const [videoUrl, setVideoUrl] = useState('');
	const [selectedAutomation, setSelectedAutomation] = useState({});
	const [enabled, setEnabled] = useState(false);

	// selected person
	const [selected, setSelected] = useState({
		fields: {
			Name: "Add a new person to get started!", // company.fields.People1Name,
			Title: null, // company.fields.People1Title,
			Image: company.fields.People1PictureUrl,
			PictureUrlOrig: null,
			PictureUrlCopy: null,
			Salary: 0, // Math.round(Math.random() * 100000),
			Responsibilities: null, // '{"value":"hello","label":"hello"}',
			DesiredUpgrades:
				'{"0":{"id":0,"value":false},"1":{"id":1,"value":true},"2":{"id":2,"value":false},"3":{"id":3,"value":true},"4":{"id":4,"value":false},"5":{"id":5,"value":false},"6":{"id":6,"value":true},"7":{"id":7,"value":true},"8":{"id":8,"value":true},"9":{"id":9,"value":true},"10":{"id":10,"value":true},"11":{"id":11,"value":true},"12":{"id":12,"value":true},"13":{"id":13,"value":true},"14":{"id":14,"value":true},"15":{"id":15,"value":true},"16":{"id":16,"value":true},"17":{"id":17,"value":true},"18":{"id":18,"value":true},"19":{"id":19,"value":true}}',
		},
	});

	// IMPORTANT:
	// The way we store fields for newPeople and people is kind of weird, for fields such as responsibilities and desiredupgrades, we keep them as strings
	// Thus, if we ever want to use them, we would have to call json.stringify
	// perhaps this is something to fix in the future, but in the mean time, we can work with what we have

	// people list from people section of airtable
	const [newPeople, setNewPeople] = useState([]);

	// this is people list from companies section of airtable
	// debugLog('important notice', JSON.parse(company.fields.People2PictureUrl)[0].fields.Responsibilities);
	const [people, setPeople] = useState(
		company.fields.People2PictureUrl !== "[]" && company.fields.People2PictureUrl ? JSON.parse(company.fields.People2PictureUrl) : []
	);

	// set to true once clay runs after person added by linkedin url
	const [personAdded, setPersonAdded] = useState("");

	// set to true once person is in airtable after clay runs
	const [personReady, setPersonReady] = useState(false);

	// denotes how many airtable poll cycles we've gone through
	// const [attempt, setAttempt] = useState(0);

	// open for title accordion
	const [open, setOpen] = useState(false);

	// open for entire automations panel
	const [totalOpen, setTotalOpen] = useState(true);

	// Create a ref for the scrollable profile page in mobile view
	const scrollableDivRef = useRef(null);

	// create ref for scrollable profile page on desktop
	const scrollableDivDeskRef = useRef(null);

	// switch page button for panel
	// true for profile select and false for profile
	const [currentPage, setCurrentPage] = useState(true);

	// automations upgrades
	const [automationUpgrades, setAutomationUpgrades] = useState({});

	// automations options
	const [automationOptions, setAutomationOptions] = useState([]);

	// number of matching title runs, can only run once
	const [once, setOnce] = useState(0);

	// ALL useEffects GO HERE----------------------------------------------------------------------------------

	// User Validation
	const { user, isSignedIn, isLoaded: isUserLoaded } = useUser()
	const [admin, setAdmin] = useState(false);
	const [automationPartners, setAutomationPartners] = useState([]);

	const [editMode, setEditMode] = useState(false);

	const [activeTab, setActiveTab] = useState(forceTab || 'directory');
	const effectiveTab = forceTab || activeTab;

	useEffect(() => {
		if (forceTab) setActiveTab(forceTab);
	}, [forceTab]);

	useEffect(() => {
		base2("automationpartners")
			.select({
				view: "Grid view",
			})
			.all()
			.then((data) => {
				const formattedData = [];
				data?.map((record) => {
					return formattedData.push({
						name: record.fields.Name,
						email: record.fields.Email
					});
				});

				setAutomationPartners(formattedData);
			})
			.catch((error) => {
				debugLog(error);
			});
	}, []);

	useEffect(() => {
		if (!isSignedIn || !isUserLoaded) return;
		if (extractDomain(user.primaryEmailAddress.emailAddress) === process.env.REACT_APP_COOL_EMAIL) {
			setAdmin(true);
		}
	}, [user, isSignedIn, isUserLoaded]);

	// same idea as airtable poll from app.js, this is to see if newPeople arrived in airtable
	useEffect(() => {
		// will only run if person is not in airtable yet
		if (personAdded) {
			const fetchData = async () => {
				try {
					// from airtable we grab the companies record
					// then we find the number of rows for companies

					const records = await base2("people")
						.select({
							view: "Grid view",
							filterByFormula: `REGEX_MATCH({Email}, '^${personAdded}$')`,
						})
						.all();

					debugLog("POLLING");

					const person = records[0];

					if (person?.fields?.Name) {
						// Perform title matching before adding to the state
						const personTitle = person.fields.Title;
						let similarTitle = "";

						if (person?.fields?.Title) {
							similarTitle = findSimilarJobTitles(personTitle, titles, 0.5);
						}

						if (similarTitle) {
							person.fields.MatchedTitle = similarTitle;
						}

						// Update new people state by adding the new person at the beginning of the array
						setNewPeople((prevPeople) => [person, ...prevPeople]);
						setPersonAdded('');
						clearInterval(intervalId);
					}
				} catch (error) {
					console.error("Error fetching data:", error);
				}
			};

			fetchData();

			let intervalId = setInterval(fetchData, 1000); // Poll every 1 second
		}
	}, [personAdded]);

	// Fetch people from people tab of airtable once they are ready
	useEffect(() => {
		if (personReady) {
			setPersonReady(false);
			base2("people")
				.select({
					view: "Grid view",
					// filterByFormula: `"({Domain} = '${company.fields.Domain} ')"`
				})
				.all()
				.then((data) => {
					data = data.filter((person) => person?.fields?.Domain == company?.fields?.Domain);

					data.map((person) => {
						const personTitle = person.fields.Title;
						let similarTitle = "";

						if (person.fields.Title) {
							similarTitle = findSimilarJobTitles(personTitle, titles, 0.5);

						}

						// this is for assigning responsibilites based on the matched title
						if (similarTitle) {
							person.fields.MatchedTitle = similarTitle;

						}
					});
					setNewPeople(data);
				})
				.catch((error) => {
					debugLog(error);
				});
		}
	}, [personReady]);

	// Fetch people from airtable at the beginning of page render
	useEffect(() => {
		base2("people")
			.select({
				view: "Grid view",
				filterByFormula: `"({Domain} = '${company.fields.Domain} ')"`,
			})
			.all()
			.then((data) => {
				data = data.filter((person) => person?.fields?.Domain == company?.fields?.Domain);

				setNewPeople(data);
			})
			.catch((error) => {
				debugLog("no valid person", error);
			});
	}, []);

	// Fetch company from airtable, for deleting old people and updating old people
	// useEffect(() => {
	//     if (deleteNow) {
	//         base2("companies")
	//         .select({ view: "Grid view" })
	//         .all()
	//         .then(records => {

	//             let updatedCompany = records.filter(
	//             cmpy => cmpy.fields.Domain === curCompany.fields.Domain
	//             )[0];

	//             if (updatedCompany) {
	//                 setCurCompany(updatedCompany)
	//                 setPeople(updatedCompany.fields.People2PictureUrl !== '[]' && updatedCompany.fields.People2PictureUrl ? JSON.parse(updatedCompany.fields.People2PictureUrl) : []);
	//             }
	//         });
	//     }
	// }, [deleteNow]);

	// used to determine is automation panel is finished loading
	useEffect(() => {
		if (selected.fields.Name !== "Add a new person to get started!" && loading) {
			setLoading(false);
		}
	}, [selected]);

	useEffect(() => {
		setTimeout(setLoading(false), 3000);
	}, []);

	function currencyFormat(num) {
		return "$" + num.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}

	// RETRIEVING DATA FOR TITLES SELECT
	useEffect(() => {
		base2("titles")
			.select({
				view: "Grid view",
			})
			.all()
			.then((data) => {

				const newArr = [];
				data?.map((record) => {
					return newArr.push({ value: record.fields.Name, label: record.fields.Name });
				});

				setTitles(newArr);
			})
			.catch((error) => {
				debugLog(error);
			});
	}, []);

	// RETRIEVING DATA FOR AUTOMATION UPGRADES
	useEffect(() => {
		if (admin) {
			base2("automations")
				.select({ view: "Grid view" })
				.all()
				.then((data) => {
					let options = [];
					let tempObject = {};
					data.map((automation) => {
						options.push({ value: automation.fields.Name, label: automation.fields.Name, description: automation.fields.Description, inputs: automation.fields.Inputs });
						tempObject[automation.fields.Name] = automation;
					});
					// debugLog(options, "options manual match")
					setAutomationOptions(options);
					setAutomationUpgrades(tempObject);
				})
				.catch((error) => {
					debugLog(error);
				});
		}
	}, []);

	// RETRIEVING MAPPING OBJECTS
	// responsibilities to automations
	useEffect(() => {
		if (admin && !Object.keys(biggerAutomationMap).includes(selected.fields.Name)) {

			const valuesToSearch = newResponsibilities.map((option) => option.value);

			// Escape any single quotes in the values.
			let escapedValues = valuesToSearch.map((value) => value.replace(/'/g, "\\'"));
			let formula = escapedValues.map((value) => `{Name} = '${value}'`).join(", ");

			base2("responsibilities")
				.select({
					filterByFormula: `OR(${formula})`,
				})
				.all()
				.then((data) => {
					let respAutomationObject = {};
					data.map((responsibility) => {
						respAutomationObject[responsibility.fields.Name] = responsibility?.fields?.AutomationUpgrades
							? JSON.parse(responsibility?.fields?.AutomationUpgrades)
							: [];
						respAutomationObject[responsibility.fields.Name + "id"] = responsibility?.id;
					});


					setBiggerAutomationMap({ ...biggerAutomationMap, [selected.fields.Name]: respAutomationObject });

				})
				.catch((error) => {
					debugLog(error);
				});
		}
	}, [newResponsibilities]);

	// create function that retrieves necessary information:
	// will need:
	// people list, number of automations for each person, title, salary,
	// i think instead of creating multiple states for everything, just use one object so that I have to create
	//   less contexts
	// State I will need: automationPeople -> {
	//      name: {
	//          upgradeQuantity:
	//          upgradeAmount:
	//          upgradeList:
	//          title:
	//          salary:
	//          pic:
	//      }
	// }
	// this state will provide everything that we need
	// maybe good idea to delete the run for all feature. Could always add back later
	// useEffect(() => {
	//     // let allAutomations = [];
	//     newPeople.map((person, i) => {

	//         setAutomationPeople(prev => ({
	//             ...prev,
	//             [person.fields.Name]: {
	//                 ...(prev[person.fields.Name] || {}),
	//                 title: person?.fields?.Title,
	//                 salary: person?.fields?.Salary,
	//                 pic: person?.fields?.PictureUrlOrig ? person?.fields?.PictureUrlOrig : company.fields.LogoUrl
	//         }}));

	//         const valuesToSearch = JSON.parse(person.fields.Responsibilities).map(option => option.value)
	//         let escapedValues = valuesToSearch.map(value => value.replace(/'/g, "\\'"));
	//         let formula = escapedValues.map(value => `{Name} = '${value}'`).join(', ');

	//         base2('responsibilities').select({
	//             filterByFormula: `OR(${formula})`,
	//         })
	//         .all()
	//         .then((data) => {
	//             let upgradeAmount = 0;
	//             let upgradeList = [];
	//             let upgradeQuantity = 0;

	//             // code was breaking before because i didn't consider undefined automations
	//             data.map(responsibility => {
	//                 const automationMatch = JSON.parse(responsibility?.fields?.AutomationUpgrades) || [];
	//                 const filteredAutomations = automationMatch.filter(upgrade => upgrade.verified).map(upgrade => upgrade.automation)
	//                 filteredAutomations.map(match => {
	//                     if (!upgradeList.includes(match)) {
	//                         upgradeList.push(match);
	//                         upgradeQuantity += 1;
	//                     }
	//                 });
	//                 upgradeAmount += JSON.parse(person.fields.Hours)[i] * person.fields.Salary * 0.8 / 40;
	//             })

	//             debugLog('running name', person.fields.Name);

	//             setAutomationPeople(prev => ({
	//                 ...prev,
	//                 [person.fields.Name]: {
	//                     ...(prev[person.fields.Name] || {}),
	//                     upgradeAmount,
	//                     upgradeList,
	//                     upgradeQuantity,
	//             }}));
	//         })
	//         .catch((error) => {
	//             debugLog(error);
	//         });

	//     });
	//     people.map((person, i) => {

	//         setAutomationPeople(prev => ({
	//             ...prev,
	//             [person.fields.Name]: {
	//                 ...(prev[person.fields.Name] || {}),
	//                 title: person?.fields?.Title,
	//                 salary: person?.fields?.Salary,
	//                 pic: person?.fields?.PictureUrlOrig ? person?.fields?.PictureUrlOrig : company.fields.LogoUrl
	//         }}));

	//         const valuesToSearch = JSON.parse(person.fields.Responsibilities).map(option => option.value)
	//         let escapedValues = valuesToSearch.map(value => value.replace(/'/g, "\\'"));
	//         let formula = escapedValues.map(value => `{Name} = '${value}'`).join(', ');

	//         base2('responsibilities').select({
	//             filterByFormula: `OR(${formula})`,
	//         })
	//         .all()
	//         .then((data) => {
	//             let upgradeAmount = 0;
	//             let upgradeList = [];
	//             let upgradeQuantity = 0;
	//             data.map(responsibility => {
	//                 const automationMatch = JSON.parse(responsibility?.fields?.AutomationUpgrades) || [];
	//                 const filteredAutomations = automationMatch.filter(upgrade => upgrade.verified).map(upgrade => upgrade.automation)
	//                 filteredAutomations.map(match => {
	//                     if (!upgradeList.includes(match)) {
	//                         upgradeList.push(match)
	//                         upgradeQuantity += 1
	//                     }
	//                 });
	//                 upgradeAmount += JSON.parse(person.fields.Hours)[i] * person.fields.Salary * 0.8 / 40;
	//             })

	//             setAutomationPeople(prev => ({
	//                 ...prev,
	//                 [person.fields.Name]: {
	//                     ...(prev[person.fields.Name] || {}),
	//                     upgradeAmount,
	//                     upgradeList,
	//                     upgradeQuantity,
	//             }}));
	//         })
	//         .catch((error) => {
	//             debugLog(error);
	//         });

	//     });
	// }, [dataReady, newPeople, people])

	// FUNCTIONS GO HERE----------------------------------------------------------------------------------

	// scrolls to the top!
	const scrollToTop = () => {
		// Use the ref to scroll the div to the top
		if (scrollableDivRef.current) {
			const scrollableDiv = scrollableDivRef.current;
			const scrollHeight = scrollableDiv.scrollTop; // the amount we need to scroll
			const scrollStep = Math.PI / (500 / 15); // calculate the scroll step (500 is duration and 15 is FPS)
			const cosParameter = scrollHeight / 2;
			let scrollCount = 0,
				scrollMargin,
				scrollInterval;

			// start the interval
			scrollInterval = setInterval(function () {
				if (scrollableDiv.scrollTop > 1) {
					scrollCount = scrollCount + 1;
					scrollMargin = cosParameter - cosParameter * Math.cos(scrollCount * scrollStep);
					scrollableDiv.scrollTop = scrollHeight - scrollMargin;
				} else clearInterval(scrollInterval);
			}, 15);
		}
	};

	const fastScrollDesktop = () => {
		if (scrollableDivDeskRef.current) {
			scrollableDivDeskRef.current.scrollTop = 0;
		}
	};

	const fastScroll = () => {
		if (scrollableDivRef.current) {
			scrollableDivRef.current.scrollTop = 0;
		}
	};

	// function that lets us add people to airtable
	function addNewPeople(e) {
		e.preventDefault();

		fetch("https://api.airtable.com/v0/" + baseId + "/" + peopleTable, {
			method: "POST",
			headers: {
				Authorization: `Bearer ${apiKey}`,
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				fields: {
					Email: e.target["personLinkedInUrl"].value,
					Domain: company.fields.Domain,
					Responsibilities:
						'[{"value":"Conceiving and implementing concepts, guidelines and strategies in various creative projects and overseeing them to completion","label":"Conceiving and implementing concepts, guidelines and strategies in various creative projects and overseeing them to completion"},{"value":"Collaborating with account executives to obtain knowledge of the clients requirements","label":"Collaborating with account executives to obtain knowledge of the clients requirements"},{"value":"Directing and motivating teams of art directors, illustrators, copywriters etc. to help them use their talents effectively","label":"Directing and not really motivating teams of art directors, illustrators, copywriters etc. to help them use their talents effectively"},{"value":"Conceive and implement concepts, guidelines and strategies in various creative projects and oversee them to completion","label":"Conceive and implement concepts, guidelines and strategies in various creative projects and oversee them to completion"},{"value":"Collaborate with account executives to obtain knowledge of the clients requirements","label":"Collaborate with account executives to obtain knowledge of the clients requirements"},{"value":"Direct and motivate teams of art directors, illustrators, copywriters etc. to help them use their talents effectively","label":"Direct and motivate teams of art directors, illustrators, copywriters etc. to help them use their talents effectively"},{"value":"Lead brainstorming/creative sessions to generate ideas","label":"Lead brainstorming/creative sessions to generate ideas"},{"value":"Write and design unique and well-crafted copy that meet clients needs as well as our own","label":"Write and design unique and well-crafted copy that meet clients needs as well as our own"},{"value":"Revise content and presentations, approve/reject ideas, provide feedback to the team","label":"Revise content and presentations, approve/reject ideas, provide feedback to the team"},{"value":"Train and guide subordinates into accomplished professionals","label":"Train and guide subordinates into accomplished professionals"},{"value":"Monitor results of team efforts and propose actions for the future","label":"Monitor results of team efforts and propose actions for the future"}]',
					Salary: 100000,
					Hours: JSON.stringify(inputData),
					DesiredUpgrades:
						'{"0":{"id":0,"value":false},"1":{"id":1,"value":false},"2":{"id":2,"value":false},"3":{"id":3,"value":false},"4":{"id":4,"value":false},"5":{"id":5,"value":false},"6":{"id":6,"value":false},"7":{"id":7,"value":false},"8":{"id":8,"value":false},"9":{"id":9,"value":false},"10":{"id":10,"value":false},"11":{"id":11,"value":false},"12":{"id":12,"value":false},"13":{"id":13,"value":false},"14":{"id":14,"value":false},"15":{"id":15,"value":false},"16":{"id":16,"value":false},"17":{"id":17,"value":false},"18":{"id":18,"value":false},"19":{"id":19,"value":false}}',
				},
			}),
		})
			.then((response) => response.json())
			.then((data) => {
				debugLog("this is what happened", data);
			})
			.catch((error) => console.error("Error the person was not added to airtable:", error));

		try {
			fetch(
				`https://mycorsproxy-tuto-35940f676099.herokuapp.com/https://api.clay.com/v3/sources/webhook/${process.env.REACT_APP_CLAY_ENRICH_PEOPLE}`,
				{
					method: "POST",
					headers: {
						Authorization: `Bearer ${clayApiKey}`,
						"Content-Type": "application/json",
						"Access-Control-Allow-Origin": "*",
						"Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
					},
					body: JSON.stringify({
						Email: e.target["personLinkedInUrl"].value,
						Domain: company.fields.Domain,
					}),
				}
			)
				// next step -> go to useEffect with domainAdded as a dependency
				.then((response) => {

					setPersonAdded(e.target["personLinkedInUrl"].value);
				});
		} catch (error) {
			console.error("Error in Fetching: ", error);
		}
	}

	// delete people from people section of airtable (newPeople)
	function handleDeleteNewPeople(id) {
		const personId = id;

		const updatedNewPeople = newPeople.filter((person) => person.id !== id);
		setNewPeople(updatedNewPeople);


		fetch("https://api.airtable.com/v0/" + baseId + "/" + peopleTable + "/" + personId, {
			method: "DELETE",
			headers: {
				Authorization: `Bearer ${apiKey}`,
			},
		})
			.then((response) => response.json())
			.then((data) => {
				debugLog("delete log", data);
			})
			.catch((error) => console.error("Error the person was not added to airtable:", error));
	}

	// delete people from companies section of airtable (people)
	function handleDeleteOldPeople(id, save) {
		const companyId = curCompany.id;

		const updatedPerson = people.filter((person) => person.fields.Name !== id.fields.Name);

		if (save) {
			setTimeout(() => {
				setPersonReady(true);
			}, 500);
		}

		setPeople(updatedPerson);

		fetch("https://api.airtable.com/v0/" + baseId + "/" + companyTable + "/" + companyId, {
			method: "PATCH",
			headers: {
				Authorization: `Bearer ${apiKey}`,
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				fields: {
					People2PictureUrl: JSON.stringify(updatedPerson),
				},
			}),
		})
			.then((response) => response.json())
			.then((data) => {
				debugLog("delete old people", data);
				// setDeleteNow(true);
			})
			.catch((error) => console.error("Error:", error));
	}

	// const changeTitle = (title) => {

	//     base2('titles').select({
	//         filterByFormula: `{Name} = '${title}'`
	//     }).eachPage(function page(records, fetchNextPage) {
	//         // This function (`page`) will get called for each page of records.
	//         debugLog("responsibilities fields values", records[0].fields.RespNameFromResponsibilities)
	//         const specificResponsibilities = records[0].fields.RespNameFromResponsibilities
	//         debugLog("spec resp", specificResponsibilities)
	//         const newArrs = []
	//         specificResponsibilities.forEach((record) => {
	//             if (newArrs.length < 19) {
	//                 newArrs.push({ value: record, label: record });
	//             }
	//         });
	//         debugLog("new Array", newArrs)
	//         setNewResponsibilities(newArrs)
	//         records.forEach(function (record) {
	//             debugLog('Retrieved now', record);
	//         });
	//         // var arr = [...responsibilities]
	//         // records.map((user) => {
	//         //     return arr.push({ value: user.login, label: user.login });
	//         // });
	//         // debugLog(arr.shift());
	//         // setOptions(arr);
	//         // debugLog(options.shift());

	//         // To fetch the next page of records, call `fetchNextPage`.
	//         // If there are more records, `page` will get called again.
	//         // If there are no more records, `done` will get called.
	//         fetchNextPage();

	//     }, function done(err) {
	//         if (err) { console.error(err); return; }
	//     });
	// };

	function createArray() {
		let arr = [];
		for (let i = 5000; i <= 500000; i += 5000) {
			arr.push({ value: i, label: currencyFormat(i) });
		}
		return arr;
	}

	let salaries = createArray();

	function handleChange(e) {
		const { id, value } = e.target;

		// Take the previous state (object), and update it
		// by spreading (copying) out the previous object,
		// and adding a new property with the id as key
		// and the value as the value.
		setInputData((prev) => ({ ...prev, [id]: value }));
	}

	const handleChangeSalary = (option) => {

		setSelectedSalary(option);
		// selected.fields.Salary = option.value;

		setSelected(selected);

		// setSelected(selected, function () {
		//     debugLog(selected);
		// });
	};

	const handleChangeTitle = (option) => {

		setSelectedOption(option);


		base2("titles")
			.select({
				filterByFormula: `{Name} = '${option.value}'`,
			})
			.eachPage(
				function page(records, fetchNextPage) {
					// This function (`page`) will get called for each page of records.

					const specificResponsibilities = records[0].fields.RespNameFromResponsibilities;

					const newArrs = [];
					specificResponsibilities.forEach((record) => {
						if (newArrs.length < 19) {
							newArrs.push({ value: record, label: record });
						}
					});

					setNewResponsibilities(newArrs);

					// var arr = [...responsibilities]
					// records.map((user) => {
					//     return arr.push({ value: user.login, label: user.login });
					// });
					// debugLog(arr.shift());
					// setOptions(arr);
					// debugLog(options.shift());

					// To fetch the next page of records, call `fetchNextPage`.
					// If there are more records, `page` will get called again.
					// If there are no more records, `done` will get called.
					fetchNextPage();
				},
				function done(err) {
					if (err) {
						console.error(err);
						return;
					}
				}
			);
	};

	function handleSwitch(i, checked) {

		// const { id, value } = e.target;
		// if(value == false){
		//     value = true
		// } else {
		//     value = false
		// }
		const id = i;

		// Take the previous state (object), and update it
		// by spreading (copying) out the previous object,
		// and adding a new property with the id as key
		// and the value as the value.

		debugLog("toggleData before", toggleData);
		setToggleData((prev) => ({ ...prev, [id]: { id: id, value: !checked } }));
		debugLog("toggleData after but async...", toggleData);
	}

	function handleReactSelectChange(option, action, i) {
		debugLog("react select everything", option.value, action, i);
		debugLog("react select responsibilities", newResponsibilities);
		debugLog("react select from given", selected.fields.Responsibilities);
		debugLog("react select from json parse", JSON.parse(selected.fields.Responsibilities));
		debugLog("react select from json parse value", JSON.parse(selected.fields.Responsibilities)[i]);

		// var jsonResp = JSON.parse(selected.fields.Responsibilities)
		// jsonResp[i].label = option.label
		// selected.fields.Responsibilities = JSON.stringify(jsonResp)
		// debugLog("react select from json parse", JSON.parse(selected.fields.Responsibilities))

		const exists = newResponsibilities.some((existingOption) => existingOption.value === option.value);

		if (!exists) {
			// The selected option is a new one
			debugLog("New option created:", i, option);
			// Add the new option to the beginning of your options array or state
			setNewResponsibilities(
				newResponsibilities.map((resp, index) => {
					if (index === i) {
						return { label: option.label, value: option.value };
					} else {
						return resp;
					}
				})
			);
		} else {
			// The selected option already exists
			debugLog("Existing option selected:", option);

			// Filter out the selected option from the existing array
			const updatedResponsibilities = newResponsibilities.filter((existingOption) => existingOption.value !== option.value);

			// Add the selected option to the beginning of the updated array
			setNewResponsibilities([option, ...updatedResponsibilities]);
		}

		// setNewResponsibilities(JSON.parse(selected.fields.Responsibilities));
		// const { id, value } = e.target;
		// const value = e
		// const id = i

		// Take the previous state (object), and update it
		// by spreading (copying) out the previous object,
		// and adding a new property with the id as key
		// and the value as the value.
		// debugLog("toggleData before", toggleData)
		// debugLog("toggleData after but async...", toggleData)
	}

	function handleSave(e, stuff) {
		// newpeople and people

		e.preventDefault();

		const arrayAsString = JSON.stringify(newResponsibilities);


		// Get all the responsibilities and save that to the people object
		var personId = selected.id;

		var inputDataObj = JSON.stringify(inputData);
		selected.fields.Salary = selectedSalary.value;
		selected.fields.Hours = inputDataObj;
		var toggleDataObj = JSON.stringify(toggleData);
		selected.fields.DesiredUpgrades = toggleDataObj;

		var requestTime = new Date().toISOString();

		const updatedNewPeople = newPeople.map((person) => {
			if (person.fields.Name === selected.fields.Name) {
				return {
					...person,
					fields: {
						...person.fields,
						Responsibilities: arrayAsString,
						Salary: selectedSalary.value,
						Hours: JSON.stringify(inputData),
						DesiredUpgrades: JSON.stringify(toggleData),
					},
				};
			}
			return person; // return the person unchanged if the condition doesn't match
		});

		setNewPeople(updatedNewPeople);

		fetch("https://api.airtable.com/v0/" + baseId + "/" + peopleTable + "/" + personId, {
			method: "PATCH",
			headers: {
				Authorization: `Bearer ${apiKey}`,
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				fields: {
					Responsibilities: arrayAsString,
					MatchedTitle: selectedOption.value,
					Salary: selectedSalary.value,
					Hours: inputDataObj,
					DesiredUpgrades: toggleDataObj,
					RequestMade: requestTime,
				},
			}),
		})
			.then((response) => response.json())
			.then((data) => {
				debugLog(data);
				setContents(
					{ type: "success", heading: "Responsibilities Saved!", message: "Thank you for updating your information." },
					setReqSavingsNotif
				);
				setShowNotif(true, setReqSavingsNotif);
			})
			.catch((error) => console.error("Error:", error));

		// if you're updating a person from the companies section of airtable
		// we will move the person from the companies table to the people table in airtable now
		if (!selected.id) {
			debugLog("update this guy:", selected.fields.Name);

			fetch("https://api.airtable.com/v0/" + baseId + "/" + peopleTable, {
				method: "POST",
				headers: {
					Authorization: `Bearer ${apiKey}`,
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					fields: {
						Email: selected.url,
						Title: selected.fields.Title,
						PictureUrlOrig: selected.fields.PictureUrlCopy,
						Name: selected.fields.Name,
						Domain: company.fields.Domain,
						Responsibilities: arrayAsString,
						Salary: selectedSalary.value,
						Hours: inputDataObj,
						DesiredUpgrades: toggleDataObj,
						RequestMade: requestTime,
					},
				}),
			})
				.then((response) => response.json())
				.then((data) => {
					debugLog(data);
					setContents(
						{ type: "success", heading: "Responsibilities Saved!", message: "Thank you for updating your information." },
						setReqSavingsNotif
					);
					setShowNotif(true, setReqSavingsNotif);
				})
				.catch((error) => console.error("Error:", error));

			const updatedPeople = people.map((person) => {
				if (person.fields.Name === selected.fields.Name) {
					return {
						...person,
						fields: {
							...person.fields,
							Responsibilities: arrayAsString,
							Salary: selectedSalary.value,
							Hours: JSON.stringify(inputData),
							DesiredUpgrades: JSON.stringify(toggleData),
						},
					};
				}
				return person; // return the person unchanged if the condition doesn't match
			});

			setPeople(updatedPeople);

			debugLog("a new people", people);

			handleDeleteOldPeople(selected, true);
		}

		// Get all the time values and save that to the people object
	}

	const handleSoftwareSelectChange = (selectedSoftware) => {
		setSelectedSoftware(selectedSoftware);
		debugLog("technologies selected", selectedSoftware)
	};

	const handleAutomationSelectChange = (selectedAutomation) => {
		setSelectedAutomation(selectedAutomation);
		debugLog("automation selected", selectedAutomation)
	};

	const handleLoomChange = (e) => {
		debugLog("videoUrl test 1", e)
		setVideoUrl(e);
		debugLog("videoUrl", videoUrl)
		debugLog("videoUrl test 2", e)
	};

	function handleRequest(event) {
		event.preventDefault();
		debugLog("Saved before string!", newResponsibilities);
		const arrayAsString = JSON.stringify(newResponsibilities);
		debugLog("Saved after made to string!", arrayAsString);

		// Get all the responsibilities and save that to the people object
		var personId = selected.id;
		debugLog("personId", personId);
		debugLog("input data", inputData);
		debugLog("toggle data", toggleData);
		var inputDataObj = JSON.stringify(inputData);
		selected.fields.Hours = inputDataObj;
		var toggleDataObj = JSON.stringify(toggleData);
		selected.fields.DesiredUpgrades = toggleDataObj;

		// TO DO - Build out zapier webhook
		var request = "Someone needs help automating their responsibilities!";
		// Client: company.fields.name
		// Name: selected.fields.name
		// Title: selected.fields.title
		// Salary: selected.fields.salary
		// Resp 1: X | Hrs/Wk: Y | $ in Labor: Z | Savings: $A | Priority: B
		// Resp 2: X | Hrs/Wk: Y | $ in Labor: Z | Savings: $A | Priority: B
		// newResponsibilities[i]

		// If True
		// Calculate the price = $/hr * Hours spent per week * 52 weeks * 0.2
		// $50/hr ($100,000 / 2000) * 2 hrs per week * 50 weeks/yr * 0.2 = $1000 price // $5,000 cost // $4,000 savings
		var quotedAutomations = []

		// All requests
		// newResponsibilities.map((resp, i) => {
		// 	// if (desiredUpgrades === true ) {
		// 		debugLog(i, resp)
		// 		debugLog("input data", inputData[i]);
		// 		debugLog("toggle data", toggleData[i]);
		// 		resp["hours"] = inputData[i]
		// 		resp["requested"] = toggleData[i]["value"]
		// 		debugLog(i, resp)
		// 		// automationDescription = "Automate " + resp.value;
		// 		// automationPrice = selected.fields.Salary / 2000 * hours * 50 * 0.2;
		// 		// quotedAutomations.push({automationDescription, automationPrice})
		// 	// }
		// })

		debugLog("new responsibilities", newResponsibilities);

		// If desired only
		newResponsibilities.map((resp, i) => {
			if (toggleData[i]["value"] === true) {
				debugLog("print all", i, resp)
				debugLog("input data", inputData[i]);
				debugLog("toggle data", toggleData[i]);
				resp["hours"] = inputData[i]
				resp["requested"] = toggleData[i]["value"]
				debugLog(i, resp)
				// automationDescription = "Automate " + resp.value;
				var automationPrice = selected.fields.Salary / 2000 * inputData[i] * 50 * 0.2;
				// debugLog("automation price", automationPrice)
				var costToBusiness = selected.fields.Salary / 2000 * inputData[i] * 50;
				// debugLog("cost to business", costToBusiness)
				var savings = costToBusiness - automationPrice;
				// debugLog("business Savings", savings)
				var automationDescription = resp["value"]
				// debugLog("automation description", automationDescription)
				var requested = resp["requested"]

				// NEW DATA
				debugLog("videoUrl", videoUrl)
				debugLog("technologies selected", selectedSoftware)
				debugLog("selected Automation", selectedAutomation)

				var loomVideoLink = videoUrl

				var technologiesUsed = selectedSoftware

				var automationSelected = selectedAutomation

				quotedAutomations.push({ automationDescription, automationPrice, requested, loomVideoLink, technologiesUsed, automationSelected })
			}
		})
		debugLog("quoted automations", quotedAutomations)

		var requestTime = new Date().toISOString();

		newPeople.map((person) => {
			if (person.fields.Name === selected.fields.Name) {
				person.fields.Responsibilities = arrayAsString;
				person.fields.Salary = selectedSalary.value;
				person.fields.Hours = JSON.stringify(inputData);
				person.fields.DesiredUpgrades = JSON.stringify(toggleData);
			}
		});

		const automation1Description = quotedAutomations?.[0]?.automationDescription ?? "No automations requested"
		const automation1Price = quotedAutomations?.[0]?.automationPrice ?? ""
		const automation2Description = quotedAutomations?.[1]?.automationDescription ?? "No automations requested"
		const automation2Price = quotedAutomations?.[1]?.automationPrice ?? ""
		const automation3Description = quotedAutomations?.[2]?.automationDescription ?? "No automations requested"
		const automation3Price = quotedAutomations?.[2]?.automationPrice ?? ""
		const automation4Description = quotedAutomations?.[3]?.automationDescription ?? "No automations requested"
		const automation4Price = quotedAutomations?.[3]?.automationPrice ?? ""
		const automation5Description = quotedAutomations?.[4]?.automationDescription ?? "No automations requested"
		const automation5Price = quotedAutomations?.[4]?.automationPrice ?? ""

		debugLog("this is a user", user)
		debugLog("this is a company", company)

		// "{\"Grants\" : [], \"Tech Discounts\" : [], \"Automations\" : [], \"LatestActivity\" : \"n/a\"}"
		// Address: "Toronto, Ontario"
		// AnnualRevenue: 4500000
		// AnnualTraffic: 1000
		// AvgDealSize: 10000
		// CompanyType: "Privately Held"
		// ConversionRate: 2
		// Country: "CA"
		// Created: "2023-06-07T18:13:56.000Z"
		// Debt: 10000
		// Description: "Bettering the world through innovation.\n\nNormative is an Innovation Services Firm.\n\nWe believe that its one thing to come up with a great idea. But until you put it in front of the customer whose problem its meant to solve, there's nothing to back it up.\n\nTo succeed, you must listen to, learn from and iterate with your customers. You need their validation to overcome internal barriers to innovation and move with the agility of a startup.\n\nUltimately, it means building products and services that make a meaningful difference to your customers and your business. We call that Evidence-Driven Innovation. Its what sets us apart - and sets you up for success."
		// Domain: "normative.com"
		// Employees: 34
		// ExcludeGrants: "Innovative Solutions Canada,Women's Program,Mitacs Accelerate International,NADF Financing Solutions,Federal Economic Development Agency for Northern Ontario,Ontario Apprenticeship Program,Fast-Track to Financing Program,Rural Enhancement Funding Stream,Enhance Your Community Funding Stream,Entrepreneurial Opportunities Program (EOP)"
		// FollowerCount: 3361
		// Founded: 2008
		// Headcount: "11-50 employees"
		// Industry: "Business Consulting and Services,Technology"
		// InterestedIn: "Southwestern Ontario Development Fund (SWODF),Scientific Research and Experimental Development (SR&ED),CanExport SME,Mitacs Elevate,NRC IRAP Financial Support,MITACS Business Strategy Internship,OCI - Digital Modernization and Adoption Plan (DMAP),FedDev Business Scale-up and Productivity (BSP) Ontario,OCI - Technology Demonstration Program"
		// Last Modified: "2024-05-02T19:01:13.000Z"
		// LikelyCustomers: "Normative"
		// LinkedInUrl: "https://www.linkedin.com/company/normative"
		// ListSize: 3000
		// LogoUrl: "https://s3.amazonaws.com/media.mixrank.com/hero-img/2a2e7ecef3912344883f921a84df5f76"
		// LongDescription: "Skip to contentServicesPeopleMissionBlogGet in touchLinkedInInstagramTwitterIdeas are not enoughGet your best opportunities to market fasterIt's one thing to come up with a great idea. But until you put it in front of the customer whose problem it's meant to solve, there's nothing to back it up.To succeed, you must listen to, learn from and iterate with your customers. You need their validation to overcome internal barriers to innovation and move with the agility of a startup.Ultimately, it means building products and services that make a meaningful difference to your customers and your business. We call that Evidence-Driven Innovation. It's what sets us apart - and sets you up for success.Michael DilaPlatform Director, National Security Innovation NetworkThe Normative team helped us understand the power of design to engage our target customers, create products based on their needs and deliver a differentiated customer experienceOur ServicesVenture ThinkingStructure and rationalize your portfolio of innovation opportunitiesInnovation Program Development →Innovation Portfolio Development →Startup ThinkingDevelop and validate your concepts to ensure they meet the market needGrowth Engineering →Concept Development →Concept Validation →Scaling ThinkingTurn your validated concepts into customer-ready products to capture the market opportunityPilot Program →Minimum Viable Product →Read our latest blog postsSee All Posts →Data You've Got Data. Now What? Read It HereTeam Coming Together Without Falling ApartRead It HereEvidence How We Built a More Balanced Technology Team Using Data & EvidenceRead It HereIn the newsStart generating the evidence you need to achieve product-market fitGet In TouchIdeas are not enough. Get your best opportunities to market faster.ServicesPeopleMissionContactBlogPrivacy PolicyLinkedInInstagramTwitterGet Up to speedIf our updates don't provide valuable information, mark us as spam. When they do, tell your friends.©2023 Normative Inc.<iframe src=\"https://www.googletagmanager.com/ns.html?id=GTM-PLZ3PJ3\"\nheight=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe>"
		// Name: "Normative"
		// OperationalCosts: 60000
		// People1Name: "Jon"
		// People1PictureUrl: "https://s3.amazonaws.com/media.mixrank.com/profilepic/443159a4911332e3b41884572ffa6b47"
		// People1Title: "People and Operations Manager"
		// People2PictureUrl: "[\n    {\n        \"dob\: \"None\",\n        \"oProfitable?: "Yes"
		// ProvinceOrState: "ON"
		// RequestEmail: "jon@normative.com,patrick@normative.com"
		// Technologies: "Dreamhost DNS, Google Apps for Business, html5shiv, Typekit, AJAX Libraries API, jQuery, Google Maps API, pjax, FlexSlider, Google Analytics, nginx, Rackspace, Facebook Domain Insights, jQuery 1.11.0, nginx 1.2, MailChimp, SPF, GStatic Google Static Content, Google Maps, jQuery Masonry, Content Delivery Network, RSS, jQuery 1.11.1, Ubuntu, Wordpress Plugins, Moment JS, Disqus, Google Universal Analytics, PHP, Pingback Support, Facebook Like, Packery, Classie, Viewport Meta, Yoast Plugins, Yoast WordPress SEO Plugin, WordPress, Retina JS, Wordpress Daily Activity, WordPress Weekly Activity, Google Hosted Libraries, Google Hosted jQuery, Sitelinks Search Box, Wordpress Monthly Activity, nginx 1.6, Amazon Route 53, Amazon, WordPress Grid, W3 Total Cache, Jetpack, Apache, Heroku Vegur Proxy, Apple Mobile Web Clips Icon, Symantec VeriSign, DigiCert SSL, IPhone / Mobile Compatible, Amazon CloudFront, React, Classnames, Careers, Amazon SSL, Amazon S3 CDN, core-js, Amazon Virginia Region, CloudFront, Hubspot, Next.js, Sanity, Global Site Tag, Cowboy, LetsEncrypt, SSL by Default, Google Tag Manager, Webpack, Organization Schema, DoubleClick.Net, Google Conversion Linker, Google Remarketing, HubSpot Analytics, Google Conversion Tracking, Heroku DNS, Google Font API, Hubspot Forms, Google Webmaster, Heroku, Vimeo, DoubleClick Bid Manager, Mailgun, Sendgrid, Matomo, Intersection Observer, My Salesforce, Vimeo CDN, RequireJS, GoDaddy CDN, Google Adsense, Google Analytics Classic, LinkedIn, Twitter, US Privacy User Signal Mechanism, Euro, Amazon S3, PostalAddress Schema, Instagram, Apple iCloud Mail, Slack, CrUX Dataset, CrUX Top 50m, jQuery 1.8.2, reCAPTCHA, Twitter Platform, Pound Sterling, Japanese Yen, COVID-19, Robots Disallow, Amazon Ireland Region, Cloudflare, Cloudflare SSL, Chakra UI, Cloudflare CDN, Cloudflare Bot Manager, Create React App, Babel, Material-UI, Express, Netlify, IPv6, lodash, Screenfull.js, Sentry, jQuery 3.4.1, Optimizely, Tealium UTAG, Tealium, DoubleClick Floodlight, Buyatab, DemDex, Adobe Marketing Cloud, Omniture SiteCatalyst, Everest Technologies, Rubicon Project, Index Exchange, AppNexus, Openads/OpenX, Pubmatic, SpotXchange, es6 promise, Adobe Analytics, Facebook Signal, Facebook SDK, Facebook for Websites, Facebook Pixel, Facebook Custom Audiences, Twitter Embedded Tweets, Storify, Font Awesome, Modernizr, Gravatar Profiles, WordPress Stats, jQuery 1.4.4, yepnope, jQuery 1.8.3, Contentful, Lazy Load for JQuery, Lazy Load, Amazon Associates, Imgur, Twitter CDN, Cloudimage, TurboSquid, crypto browserify, Elliptic, Day.js, Apollo GraphQL, WordPress 5.9, jQuery 2.2.4, Australian English, Googlebot Disallow, jsDelivr, CDN JS, Apple Mobile Web App Capable, Apple Mobile Web App Status Bar Style, Apple Mobile Web Clips Startup, Ember, Clipboard.js, Cloudflare JS, Docusaurus, Raven JS"
		// bccEmails: "calvin@getupgraded.ca,prayaag@getupgraded.ca,yuxuan@getupgraded.ca,henry@getupgraded.ca,samson@getupgraded.ca"
		// blurMe: "false"
		// ccEmails: "haris@getupgraded.ca,will@getupgraded.ca,daniel@getupgraded.ca"
		// fromName: "Haris"
		// lastSent: "04/29/2024"
		// reportingEmails: "true"
		// sendFrequency: 14
		// subscribed?: "false"

		let htmlBody = quotedAutomations.map((automation, count) => {
			return (
				`<p style="font-size:14px;line-height:24px;margin:16px 0;color:rgb(0,0,0)">Automation ${count + 1}: ${automation.automationDescription}</p>
				<p style="font-size:14px;line-height:24px;margin:16px 0;color:rgb(0,0,0)">Automation ${count + 1} Budget: $${automation.automationPrice}</p>`
			)
		}).join("").toString();

		const userEmail = user.primaryEmailAddress.emailAddress;

		// TODO: Fix to only run for the automations that are selected

		debugLog("automationPartners", automationPartners.map(partner => partner.email).join(', '));

		// OPTIMIZED SO ONE REQUEST WITH ALL INFO
		// Create an array that contains all automation data

		// ZAP LINK https://zapier.com/editor/257666351/draft/_GEN_1726134195674/setup
		// ZAP LINKhttps://zapier.com/editor/257666351/published/_GEN_1726134195674/sample

		// Calculate total budget and total savings
		const totalBudget = quotedAutomations.reduce((sum, automation) => sum + automation?.automationPrice, 0);
		const totalSavings = quotedAutomations.reduce((sum, automation) => sum + (automation?.automationPrice * 5), 0);

		// Create an array that contains all automation data including additional fields
		const automationDetails = quotedAutomations.map(automation => ({
			AutomationDescription: automation?.automationDescription,
			Budget: currencyFormat(automation?.automationPrice),
			Savings: currencyFormat(automation?.automationPrice * 5),
			LoomVideoLink: automation?.loomVideoLink?.toString() || '',
			TechnologiesUsed: automation?.technologiesUsed.map(technology => technology.value).join(','),
			AutomationSelected: automation?.automationSelected?.value || ''
		}));

		// Send a single request to Zapier containing all automations and partners
		if (enabled) {
			fetch('https://hooks.zapier.com/hooks/catch/13965335/2hrgawx/', {
				method: "POST",
				body: JSON.stringify({
					fields: {
						CompanyName: company?.fields?.Name,
						ClientEmail: company?.fields?.RequestEmail,
						RequesterEmail: userEmail,
						PartnerEmail: automationPartners.map(partner => partner.email).join(','),  // Join all partner emails
						Automations: automationDetails,  // Send all automation data as an array
						TotalBudget: currencyFormat(totalBudget),  // Include total budget
						TotalSavings: currencyFormat(totalSavings),  // Include total savings
						ClientName: '',
						Type: "Automation",
						Date: new Date().toLocaleDateString("en-US", { year: "numeric", month: "2-digit", day: "2-digit" }),
					}
				})
			});
		}


		//  END OF NEW CALL

		for (const automation of quotedAutomations) {
			// TURN OFF DURING TESTING

			debugLog(company?.fields?.Name, "company?.fields?.Name")

			debugLog(automation, "automation")
			debugLog(automation?.loomVideoLink, automation?.technologiesUsed, automation?.automationSelected)
		}

		// // Update the person in airtable
		fetch("https://api.airtable.com/v0/" + baseId + "/" + peopleTable + "/" + personId, {
			method: "PATCH",
			headers: {
				Authorization: `Bearer ${apiKey}`,
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				fields: {
					Responsibilities: arrayAsString,
					Salary: selected.fields.Salary,
					Hours: inputDataObj,
					DesiredUpgrades: toggleDataObj,
					RequestMade: requestTime,
				},
			}),
		})
			.then((response) => response.json())
			.then((data) => {
				debugLog(data);
				setContents({ type: "success", heading: "Request sent!", message: "Your automations will be ready shortly." }, setReqSavingsNotif);
				setShowNotif(true, setReqSavingsNotif);
			})
			.catch((error) => console.error("Error:", error));

		// if you're updating a person from the companies section of airtable
		if (!selected.id) {
			debugLog("update this guy:", selected.fields.Name);

			fetch("https://api.airtable.com/v0/" + baseId + "/" + peopleTable, {
				method: "POST",
				headers: {
					Authorization: `Bearer ${apiKey}`,
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					fields: {
						Email: selected.url,
						Title: selected.fields.Title,
						PictureUrlOrig: selected.fields.PictureUrlCopy,
						Name: selected.fields.Name,
						Domain: company.fields.Domain,
						Responsibilities: arrayAsString,
						Salary: selectedSalary.value,
						Hours: inputDataObj,
						DesiredUpgrades: toggleDataObj,
						RequestMade: requestTime,
					},
				}),
			})
				.then((response) => response.json())
				.then((data) => {
					debugLog(data);
					setContents(
						{ type: "success", heading: "Responsibilities Saved!", message: "Thank you for updating your information." },
						setReqSavingsNotif
					);
					setShowNotif(true, setReqSavingsNotif);
				})
				.catch((error) => console.error("Error:", error));

			people.map((person) => {
				if (person.fields.Name === selected.fields.Name) {
					person.fields.Responsibilities = arrayAsString;
					person.fields.Salary = selectedSalary.value;
					person.fields.Hours = JSON.stringify(inputData);
					person.fields.DesiredUpgrades = JSON.stringify(toggleData);
				}
			});

			debugLog("a new people", people);

			handleDeleteOldPeople(selected, true);
		}
	}

	function setNewResp(person) {
		debugLog("incoming person", person);
		const fakeResp = [
			{
				value:
					"Conceiving and implementing concepts, guidelines and strategies in various creative projects and overseeing them to completion",
				label:
					"Conceiving and implementing concepts, guidelines and strategies in various creative projects and overseeing them to completion",
			},
			{
				value: "Collaborating with account executives to obtain knowledge of the clients requirements",
				label: "Collaborating with account executives to obtain knowledge of the clients requirements",
			},
			{
				value: "Directing and motivating teams of art directors, illustrators, copywriters etc. to help them use their talents effectively",
				label:
					"Directing and not really motivating teams of art directors, illustrators, copywriters etc. to help them use their talents effectively",
			},
			{
				value: "Conceive and implement concepts, guidelines and strategies in various creative projects and oversee them to completion",
				label: "Conceive and implement concepts, guidelines and strategies in various creative projects and oversee them to completion",
			},
			{
				value: "Collaborate with account executives to obtain knowledge of the clients requirements",
				label: "Collaborate with account executives to obtain knowledge of the clients requirements",
			},
			{
				value: "Direct and motivate teams of art directors, illustrators, copywriters etc. to help them use their talents effectively",
				label: "Direct and motivate teams of art directors, illustrators, copywriters etc. to help them use their talents effectively",
			},
			{ value: "Lead brainstorming/creative sessions to generate ideas", label: "Lead brainstorming/creative sessions to generate ideas" },
			{
				value: "Write and design unique and well-crafted copy that meet clients needs as well as our own",
				label: "Write and design unique and well-crafted copy that meet clients needs as well as our own",
			},
			{
				value: "Revise content and presentations, approve/reject ideas, provide feedback to the team",
				label: "Revise content and presentations, approve/reject ideas, provide feedback to the team",
			},
			{
				value: "Train and guide subordinates into accomplished professionals",
				label: "Train and guide subordinates into accomplished professionals",
			},
			{
				value: "Monitor results of team efforts and propose actions for the future",
				label: "Monitor results of team efforts and propose actions for the future",
			},
			{
				value: "Proven experience as a creative director or in a similar creative role",
				label: "Proven experience as a creative director or in a similar creative role",
			},
			{
				value: "Hand-on experience in creative process, marketing, graphic design and brand development",
				label: "Hand-on experience in creative process, marketing, graphic design and brand development",
			},
			{
				value: "Excellent working knowledge of software such as Photoshop, Illustrator, InDesign etc.",
				label: "Excellent working knowledge of software such as Photoshop, Illustrator, InDesign etc.",
			},
			{ value: "Outstanding leadership and organization skills", label: "Outstanding leadership and organization skills" },
			{ value: "Exemplary interpersonal and analytical abilities", label: "Exemplary interpersonal and analytical abilities" },
			{
				value: "BSc/BA in advertising, fine art, design or relevant field; MSc/MA will be considered an asset",
				label: "BSc/BA in advertising, fine art, design or relevant field; MSc/MA will be considered an asset",
			},
		];
		debugLog("fakeResp", fakeResp);
		debugLog("fakeResp string", JSON.stringify(fakeResp));
		debugLog("person.fields", person.fields);
		if (!person.fields) {
			person.fields = {
				Name: person.name,
				Title: person.title,
				Image: person.picture_url_orig,
				PictureUrlCopy: person.picture_url_orig,
				Salary: person.salary,
				Responsibilities:
					'[{"value":"Conceiving and implementing concepts, guidelines and strategies in various creative projects and overseeing them to completion","label":"Conceiving and implementing concepts, guidelines and strategies in various creative projects and overseeing them to completion"},{"value":"Collaborating with account executives to obtain knowledge of the clients requirements","label":"Collaborating with account executives to obtain knowledge of the clients requirements"},{"value":"Directing and motivating teams of art directors, illustrators, copywriters etc. to help them use their talents effectively","label":"Directing and not really motivating teams of art directors, illustrators, copywriters etc. to help them use their talents effectively"},{"value":"Conceive and implement concepts, guidelines and strategies in various creative projects and oversee them to completion","label":"Conceive and implement concepts, guidelines and strategies in various creative projects and oversee them to completion"},{"value":"Collaborate with account executives to obtain knowledge of the clients requirements","label":"Collaborate with account executives to obtain knowledge of the clients requirements"},{"value":"Direct and motivate teams of art directors, illustrators, copywriters etc. to help them use their talents effectively","label":"Direct and motivate teams of art directors, illustrators, copywriters etc. to help them use their talents effectively"},{"value":"Lead brainstorming/creative sessions to generate ideas","label":"Lead brainstorming/creative sessions to generate ideas"},{"value":"Write and design unique and well-crafted copy that meet clients needs as well as our own","label":"Write and design unique and well-crafted copy that meet clients needs as well as our own"},{"value":"Revise content and presentations, approve/reject ideas, provide feedback to the team","label":"Revise content and presentations, approve/reject ideas, provide feedback to the team"},{"value":"Train and guide subordinates into accomplished professionals","label":"Train and guide subordinates into accomplished professionals"},{"value":"Monitor results of team efforts and propose actions for the future","label":"Monitor results of team efforts and propose actions for the future"}]',
				cpus: "12 CPUs",
				disk: "1024 GB SSD disk",
				department: "Optimization",
				email: "lindsay.walton@example.com",
				role: "Member",
			};
		}
		// person?.fields?.Responsibilities ? person?.fields?.Responsibilities : person.fields = {
		//     "Responsibilities" : JSON.stringify(fakeResp)
		// }
		debugLog("resetting resp", JSON.parse(person.fields.Responsibilities));

		setNewResponsibilities(JSON.parse(person.fields.Responsibilities));
	}

	// matching responsibility to automations upgrade
	// function matchAutomations(resp, upgrades, threshold) {
	//     // normalize the sentence
	//     let respDescription = nlp(resp).normalize().out('text');
	//     let upgradeDescriptions = upgrades.map(upgrade => ({
	//         upgrade: upgrade,
	//         description: nlp(upgrade.fields.Description).normalize().out('text')
	//     }));

	//     // fuse js approach
	//     // cons: slow and inaccurate
	//     // const options = {
	//     //     shouldSort: true,
	//     //     threshold: threshold, // Adjust this threshold to control the fuzziness of the matching
	//     //     keys: ['description'], // Specify the object property to search for job titles
	//     // };

	//     // const fuse = new Fuse(upgradeDescriptions, options);
	//     // const results = fuse.search(respDescription);

	//     // const matchedUpgrades = results.map(result => result.item.upgrade);
	//     // return matchedUpgrades.slice(0, 3);

	//     // combining both compromise and fuse.js
	//     // first gets the verbs and nouns from the responsibility description
	//     // then checks if automation upgrade contains at least one of the noun/verb
	//     // then does another check using fuse.js to get best result
	//     const respKeywords = nlp(respDescription)
	//     .nouns()
	//     .concat(nlp(respDescription).verbs())
	//     .out('array');

	//     const result = upgradeDescriptions.filter(upgrade => respKeywords.some(keyword => nlp(upgrade.description).has(keyword)));

	//     const options = {
	//         shouldSort: true,
	//         threshold: threshold, // Adjust this threshold to control the fuzziness of the matching
	//         keys: ['description'], // Specify the object property to search for job titles
	//     };

	//     const fuse = new Fuse(result, options);
	//     const results = fuse.search(respDescription);

	//     const matchedUpgrades = results.map(result => result.item.upgrade);
	//     return matchedUpgrades.slice(0, 3);

	// }

	// this function is for getting responsibilities for a title
	function getResp(title) {
		return new Promise((resolve, reject) => {
			base2("titles")
				.select({
					filterByFormula: `{Name} = '${title}'`,
				})
				.eachPage(function page(records, fetchNextPage) {
					const specificResponsibilities = records[0].fields.RespNameFromResponsibilities;
					const newArrs = [];
					specificResponsibilities.forEach((record) => {
						// to make sure we have enough toggles, we limit the amount of responsibilities
						if (newArrs.length < 19) {
							newArrs.push({ value: record, label: record });
						}
					});
					fetchNextPage();
					resolve(newArrs); // resolves the promise with newArrs
				});
		});
	}

	// THIS SECTION IS DEDICATED TO MATCHING TITLES-------------------------------------------------------------------
	function findSimilarJobTitles(title, jobTitles, threshold) {
		const options = {
			shouldSort: true,
			threshold: threshold, // Adjust this threshold to control the fuzziness of the matching
			keys: ["title"], // Specify the object property to search for job titles
		};

		const fuse = new Fuse(
			jobTitles.map((jobTitle) => jobTitle.value).map((title) => ({ title })),
			options
		);

		const results = fuse.search(title);

		const matchedJobTitles = results?.map((result) => result.item.title);


		return matchedJobTitles[0];
	}

	useEffect(() => {

		if (titles.length !== 0 && (newPeople.length !== 0 || people.length !== 0) && once === 0) {
			if (titles.length !== 0 && newPeople.length !== 0) {
				newPeople.map((person) => {
					if (!person.salary) {
						person.salary = Math.round(Math.random() * (140000 - 80000) + 80000);
					}
					const personTitle = person.fields.Title;
					let similarTitle = "";

					if (person.fields.Title) {
						similarTitle = findSimilarJobTitles(personTitle, titles, 0.5);
					}

					// this is for assigning responsibilites based on the matched title
					if (similarTitle && !person.fields.MatchedTitle) {
						person.fields.MatchedTitle = similarTitle;
					}

					// underconstruction TODO: @Raymond, this makes sure we display added responsibilities at inital render
					// we also have to find a different way to switch between people. We call changeTitle every time we switch people. Not good.
					// if (person.fields.Responsibilities && person.fields.Responsibilities.some(responsibility => responsibility.__isNew__)) {

					// }
				});

				if (newPeople[0]) {
					setSelected(newPeople[0]);
					setToggleData(JSON.parse(newPeople[0].fields.DesiredUpgrades));
					setSelectedOption({ value: newPeople[0].fields.MatchedTitle, label: newPeople[0].fields.MatchedTitle });
					// changeTitle(newPeople[0].fields.MatchedTitle)
					setNewResponsibilities(JSON.parse(newPeople[0].fields.Responsibilities));
				}
			}

			if (titles.length !== 0 && people.length !== 0) {
				people.forEach((person) => {

					if (!person.salary) {
						person.salary = Math.round(Math.random() * (140000 - 80000) + 80000);
					}
					if (!person.fields) {
						person.fields = {
							Name: person.name,
							Title: person.title,
							Image: person.picture_url_orig,
							PictureUrlCopy: person.picture_url_orig,
							Salary: person.salary,
							Responsibilities:
								'[{"value":"Conceiving and implementing concepts, guidelines and strategies in various creative projects and overseeing them to completion","label":"Conceiving and implementing concepts, guidelines and strategies in various creative projects and overseeing them to completion"},{"value":"Collaborating with account executives to obtain knowledge of the clients requirements","label":"Collaborating with account executives to obtain knowledge of the clients requirements"},{"value":"Directing and motivating teams of art directors, illustrators, copywriters etc. to help them use their talents effectively","label":"Directing and not really motivating teams of art directors, illustrators, copywriters etc. to help them use their talents effectively"},{"value":"Conceive and implement concepts, guidelines and strategies in various creative projects and oversee them to completion","label":"Conceive and implement concepts, guidelines and strategies in various creative projects and oversee them to completion"},{"value":"Collaborate with account executives to obtain knowledge of the clients requirements","label":"Collaborate with account executives to obtain knowledge of the clients requirements"},{"value":"Direct and motivate teams of art directors, illustrators, copywriters etc. to help them use their talents effectively","label":"Direct and motivate teams of art directors, illustrators, copywriters etc. to help them use their talents effectively"},{"value":"Lead brainstorming/creative sessions to generate ideas","label":"Lead brainstorming/creative sessions to generate ideas"},{"value":"Write and design unique and well-crafted copy that meet clients needs as well as our own","label":"Write and design unique and well-crafted copy that meet clients needs as well as our own"},{"value":"Revise content and presentations, approve/reject ideas, provide feedback to the team","label":"Revise content and presentations, approve/reject ideas, provide feedback to the team"},{"value":"Train and guide subordinates into accomplished professionals","label":"Train and guide subordinates into accomplished professionals"},{"value":"Monitor results of team efforts and propose actions for the future","label":"Monitor results of team efforts and propose actions for the future"}]',
							Hours: JSON.stringify(inputData),
							DesiredUpgrades: JSON.stringify(toggleData),
						};
					}
				});
				people.map((person) => {
					// debugLog('yes it is', person.fields.Responsibilities)
					const personTitle = person.fields.Title;
					let similarTitle = "";

					if (person.fields.Title) {
						similarTitle = findSimilarJobTitles(personTitle, titles, 0.5);
					}

					// this is for assigning responsibilites based on the matched title
					if (similarTitle) {
						person.fields.MatchedTitle = similarTitle;
						async function fetchAndLog(similarTitle) {
							const newArrs = await getResp(similarTitle);
							return newArrs;
						}
						fetchAndLog(similarTitle).then((newArrs) => {

							// stupid function sometimes run twice
							if (newArrs) {
								person.fields.Responsibilities = JSON.stringify(newArrs);
							}
						});

					}
				});
				if (people[0] && !newPeople[0]) {
					setSelected(people[0]);
					setToggleData(JSON.parse(people[0].fields.DesiredUpgrades));
					setSelectedOption({ value: people[0].fields.MatchedTitle, label: people[0].fields.MatchedTitle });
					// changeTitle(people[0].fields.MatchedTitle)
					setNewResponsibilities(JSON.parse(people[0].fields.Responsibilities));
				}

			}
			setOnce(once + 1);
			setDataReady(true);
		}
	}, [titles, newPeople, people]);

	/*
  -----------------------
	   Notifications
  
	*/

	// Savings Estimate Notification
	const [reqSavingsNotif, setReqSavingsNotif] = useState({ showNotif: false, contents: { type: "", heading: "", message: "" } });

	return (
		<>
			{/* Desktop View */}
			<div className={hideTabBar ? "block" : "lg:block"}>
				<div class="col-span-2" ref={scrollableDivDeskRef}>
					{/* Tabs — hidden when opened from AutomateExperience FAB modal */}
					{!hideTabBar && (
						<div className="border-b border-gray-200 mb-5">
							<nav className="-mb-px flex" aria-label="Tabs">
								<button
									onClick={() => setActiveTab('directory')}
									className={classNames(
										effectiveTab === 'directory'
											? 'border-gray-900 text-gray-900'
											: 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
										'w-1/2 border-b-2 py-4 px-1 text-center text-sm font-medium'
									)}
								>
									AI & Automations Directory
								</button>
								<button
									onClick={() => setActiveTab('responsibilities')}
									className={classNames(
										effectiveTab === 'responsibilities'
											? 'border-gray-900 text-gray-900'
											: 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
										'w-1/2 border-b-2 py-4 px-1 text-center text-sm font-medium'
									)}
								>
									Automate Team Responsibilities
								</button>
							</nav>
						</div>
					)}


					{effectiveTab === 'directory' ? (
						<AutomationDirectory 
							company={company}
							runTour={false}
							setRunTour={() => {}}
							admin={false}
							isAdmin={false}
							isDarkMode={false}
							setNotification={() => {}}
							isFiltersOpen={false}
							setIsFiltersOpen={() => {}}
							filters={{ customerFocus: [], industries: [], sizes: [], stages: [] }}
							setFilters={() => {}}
							companyData={null}
							setCompanyData={() => {}}
							categories={[]}
							setCategories={() => {}}
							stages={[]}
							setStages={() => {}}
							selectedCategory="all"
							setSelectedCategory={() => {}}
							selectedStage="all"
							setSelectedStage={() => {}}
							showPrioritizedList={false}
							setShowPrioritizedList={() => {}}
							handleStageChange={() => {}}
							prioritizedIds={[]}
							setPrioritizedIds={() => {}}
							allCards={[]}
							setAllCards={() => {}}
						/>
					) : (
						<div className="bg-white px-2 pt-5 pb-2 sm:px-6">
							{/* Your existing table content */}
							{loading ? (
								<>
									<Skeleton height={20} />
									<Skeleton height={40} />
									<Skeleton className="mt-8" height={20} />
									<Skeleton height={40} />
									<Skeleton className="mt-8" height={20} />
									<Skeleton height={40} />
									<Skeleton className="mt-8" height={20} />
									<Skeleton height={40} />
								</>
							) : (
								<table className="min-w-full divide-y divide-gray-300">
									{/* Team Responsibilities Panel */}
									<div className="relative">
										{fullBlur && <button
											type="button"
											onClick={() => {
												const currentSearch = location.search;
												window.scrollTo({ top: 0 });
												navigate(`/pricing${currentSearch}`);
											}}
											class="absolute z-30 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white shadow-xl bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-lg px-5 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
										>
											<LockClosedIcon className="mr-4 h-5 w-5 inline" /> Sign Up To Unlock {company?.fields ? currencyFormat(company.fields.Employees * 20000) + " In" : "These"} Labour Savings via Automations

										</button>}
										<div class={`${fullBlur && 'blurred overflow-hidden pointer-events-none'} grid grid-cols-3 gap-4`}>
											<div class="max-h-[630px] overflow-y-scroll">
												<div>
													<div className="text-center">
														<svg className="mx-auto h-10 w-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 48 48" aria-hidden="true">
															<path
																strokeLinecap="round"
																strokeLinejoin="round"
																strokeWidth={2}
																d="M34 40h10v-4a6 6 0 00-10.712-3.714M34 40H14m20 0v-4a9.971 9.971 0 00-.712-3.714M14 40H4v-4a6 6 0 0110.713-3.714M14 40v-4c0-1.313.253-2.566.713-3.714m0 0A10.003 10.003 0 0124 26c4.21 0 7.813 2.602 9.288 6.286M30 14a6 6 0 11-12 0 6 6 0 0112 0zm12 6a4 4 0 11-8 0 4 4 0 018 0zm-28 0a4 4 0 11-8 0 4 4 0 018 0z"
															/>
														</svg>
														<h2 className="mt-1 text-base font-semibold leading-6 text-gray-900">Add team members</h2>
													</div>

													<form className="space-y-6 px-3 -mt-2 pb-4" method="POST" onSubmit={addNewPeople}>
														<label htmlFor="email" className="sr-only">
															Linkedin Url
														</label>
														<input
															type="text"
															name="personLinkedInUrl"
															id="personLinkedInUrl"
															className="inline w-9/12 rounded-md rounded-none rounded-l-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
															placeholder="Enter a personal linkedin url"
														/>
														<button
															type="submit"
															className="relative -ml-px inline-flex items-center gap-x-1.5 rounded-r-md px-3 py-2 text-sm font-semibold text-white bg-black ring-1 ring-inset ring-gray-300 hover:bg-gray-800"
														>
															Add
														</button>
													</form>
												</div>
												<RadioGroup
													value={selected}
													onChange={(value) => {
														setNewResp(value);
														setToggleData(JSON.parse(value.fields.DesiredUpgrades));
														setSelected(value);
														setSelectedOption({ value: value.fields.MatchedTitle, label: value.fields.MatchedTitle });
														setNewResponsibilities(JSON.parse(value.fields.Responsibilities));
														setInputData(JSON.parse(value.fields.Hours));
														debugLog("really selected", value);
													}}
												>
													<RadioGroup.Label className="sr-only">Server size</RadioGroup.Label>
													<div className="space-y-4 mx-4">
														{newPeople
															? newPeople
																.filter((person) => person?.fields?.Domain == company?.fields?.Domain)
																.map((plan) => (
																	<RadioGroup.Option
																		key={JSON.stringify(plan)}
																		value={plan}
																		onClick={() => fastScrollDesktop()}
																		className={({ checked, active }) =>
																			classNames(
																				checked ? "border-transparent" : "border-gray-300",
																				active ? "border-gray-800 ring-2 ring-gray-800" : "",
																				"relative block cursor-pointer rounded-lg border bg-white px-6 py-4 shadow-sm focus:outline-none sm:flex sm:justify-between"
																			)
																		}
																	>
																		{({ active, checked }) => (
																			<>
																				<div className="flex items-center mx-2">
																					<div className="h-11 w-11 flex-shrink-0">
																						<img
																							className="h-11 w-11 rounded-full"
																							src={plan?.fields?.PictureUrlOrig ? plan?.fields?.PictureUrlOrig : company.fields.LogoUrl}
																							alt=""
																						/>
																					</div>
																					<div className="ml-4">
																						<div className="font-medium text-gray-900">{plan?.fields?.Name}</div>
																						<div className="mt-1 text-gray-500">{plan?.fields?.Title}</div>
																					</div>
																				</div>
																				<span
																					className={classNames(
																						active ? "border" : "border-2",
																						checked ? "border-gray-600" : "border-transparent",
																						"pointer-events-none absolute -inset-px rounded-lg"
																					)}
																					aria-hidden="true"
																				/>
																				<button class="ml-8 text-gray-200 hover:text-black" onClick={() => handleDeleteNewPeople(plan.id)}>
																					<TrashIcon className="h-5 w-5 text-xl" aria-hidden="true" />
																				</button>
																			</>
																		)}
																	</RadioGroup.Option>
																))
															: null}

														{people
															? people.map((plan) => (
																<RadioGroup.Option
																	key={JSON.stringify(plan)}
																	value={plan}
																	onClick={() => fastScrollDesktop()}
																	className={({ checked, active }) =>
																		classNames(
																			checked ? "border-transparent" : "border-gray-300",
																			active ? "border-gray-800 ring-2 ring-gray-800" : "",
																			"relative block cursor-pointer rounded-lg border bg-white px-6 py-4 shadow-sm focus:outline-none sm:flex sm:justify-between"
																		)
																	}
																>
																	{({ active, checked }) => (
																		<>
																			<div className="flex items-center mx-2">
																				<div className="h-11 w-11 flex-shrink-0">
																					<img
																						className="h-11 w-11 rounded-full"
																						src={plan.picture_url_orig ? plan.picture_url_orig : company.fields.LogoUrl}
																						alt=""
																					/>
																				</div>
																				<div className="ml-4">
																					<div className="font-medium text-gray-900">{plan.name}</div>
																					<div className="mt-1 text-gray-500">{plan.title}</div>
																				</div>
																			</div>
																			<span
																				className={classNames(
																					active ? "border" : "border-2",
																					checked ? "border-indigo-600" : "border-transparent",
																					"pointer-events-none absolute -inset-px rounded-lg"
																				)}
																				aria-hidden="true"
																			/>
																			<button class="ml-8 text-gray-200 hover:text-black" onClick={() => handleDeleteOldPeople(plan)}>
																				<TrashIcon className="h-5 w-5 text-xl" aria-hidden="true" />
																			</button>
																		</>
																	)}
																</RadioGroup.Option>
															))
															: null}
													</div>
												</RadioGroup>
											</div>

											<div class="col-span-2 max-h-[630px] overflow-y-scroll overflow-x-hidden" ref={scrollableDivDeskRef}>
												<div className="bg-white px-2 pt-5 pb-2 sm:px-6">
													<div className="-ml-4 -mt-4 flex flex-wrap items-center justify-between sm:flex-nowrap">
														<div className="flex-shrink-0">
															<img
																className="h-10 w-10 rounded-full"
																src={
																	selected?.fields?.PictureUrlOrig
																		? selected.fields.PictureUrlOrig
																		: selected?.fields?.PictureUrlCopy
																			? selected.fields.PictureUrlCopy
																			: company.fields.LogoUrl
																}
																alt=""
															/>
														</div>
														<div className="ml-2 text-left w-[400px]">
															<h4 className="text-base font-semibold leading-6 text-gray-900">
																{selected?.fields?.Name && selected?.fields?.Name.length > 60
																	? selected.fields.Name.substring(0, 60) + ".."
																	: selected?.fields?.Name
																		? selected.fields.Name
																		: "Add a new person to get started!"}
																<br />
																{selected?.fields?.Title && selected?.fields?.Title.length > 60
																	? selected.fields.Title.substring(0, 60) + ".."
																	: selected?.fields?.Title
																		? selected.fields.Title + ", "
																		: null}
																{selected?.fields?.Name && selected.fields.Salary !== 0 ? currencyFormat(selected.fields.Salary) + "/yr" : null}
															</h4>
															<p className="mt-1 text-sm text-gray-500 font-light">
																Responsibilities & savings working{" "}
																{selected?.fields?.Name && selected.fields.Salary !== 0
																	? Object.values(inputData).reduce((acc, c) => {
																		return acc + +c;
																	}, 0)
																	: "0"}{" "}
																hrs per wk
															</p>
														</div>
														{/* Automations to Partners */}
														<Switch
															checked={enabled}
															onChange={(checked) => {
																setEnabled(checked);
																debugLog("enabled", checked);
															}}
															className={`${enabled ? "bg-gray-700" : "bg-gray-200"} mr-2 relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2`}
														>
															<span className={`${enabled ? "translate-x-5" : "translate-x-0"} mr-2 pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`}
															/>
														</Switch>
														<button
															class="box-border h-10 relative z-10 inline-flex items-center justify-center w-auto px-4 py-2 overflow-hidden font-bold text-white transition-all duration-300 bg-gray-900 rounded-md cursor-pointer group ring-offset-2 ring-1 ring-gray-300 ring-offset-gray-200 hover:ring-offset-gray-500 ease focus:outline-none"
															onClick={handleSave}
														>
															<span class="absolute bottom-0 right-0 w-8 h-20 -mb-8 -mr-5 transition-all duration-300 ease-out transform rotate-45 translate-x-1 bg-white opacity-10 group-hover:translate-x-0" />
															<span class="absolute top-0 left-0 w-20 h-8 -mt-1 -ml-12 transition-all duration-300 ease-out transform -rotate-45 -translate-x-1 bg-white opacity-10 group-hover:translate-x-0" />
															<span class="relative flex items-center text-sm">Save</span>
														</button>
														<button
															class="ml-2 box-border h-10 relative z-10 inline-flex items-center justify-center w-56 px-1 py-2 overflow-hidden font-bold text-white transition-all duration-300 bg-gray-900 rounded-md cursor-pointer group ring-offset-2 ring-1 ring-gray-300 ring-offset-gray-200 hover:ring-offset-gray-500 ease focus:outline-none"
															onClick={handleRequest}
														>
															<span class="absolute bottom-0 right-0 w-10 h-20 -mb-8 -mr-5 transition-all duration-300 ease-out transform rotate-45 translate-x-1 bg-white opacity-10 group-hover:translate-x-0" />
															<span class="absolute top-0 left-0 w-22 h-8 -mt-1 -ml-10 transition-all duration-300 ease-out transform -rotate-45 -translate-x-1 bg-white opacity-10 group-hover:translate-x-0" />
															<span class="relative flex items-center text-sm">
																<svg
																	class="relative w-4 h-4 mr-2 text-white"
																	fill="none"
																	stroke="currentColor"
																	viewBox="0 0 24 24"
																	xmlns="http://www.w3.org/2000/svg"
																>
																	<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
																</svg>
																Request Automations
															</span>
														</button>
													</div>
												</div>
												<Fragment>
													<Accordion accordion open={open} icon={<></>}>
														<AccordionHeader children={""} onClick={() => setOpen(!open)}>
															<Icon id={1} open={open} />
														</AccordionHeader>

														<AccordionBody>
															<div className="border-b border-gray-200 bg-white px-4 py-5 sm:px-6">
																<div className="w-full">
																	{/* { selected.fields.Responsibilities }
																										<br />
																										<br />
																										<br />
																								{ JSON.stringify(newResponsibilities) } */}
																</div>
																<div className="-ml-4 -mt-6 flex flex-wrap items-center justify-between sm:flex-nowrap">
																	<div className="w-50%">
																		<label htmlFor="location" className="block text-sm font-medium leading-6 text-gray-900">
																			Title
																		</label>
																		<Select
																			options={titles}
																			value={selectedOption}
																			onChange={handleChangeTitle}
																			name="titles"
																			menuPortalTarget={document.body}
																			className="w-[270px]"
																			styles={{
																				menu: (base) => ({
																					...base,
																					maxHeight: "auto", // Adjusting to auto to fit content
																					overflowY: "visible", // Adjusting to visible to fit content
																				}),
																				singleValue: (base) => ({
																					...base,
																					overflow: "visible", // Adjusting to visible to show all content
																					maxHeight: "none", // Removing max-height restriction
																					textOverflow: "clip", // Adjusting to clip to avoid truncation
																					whiteSpace: "normal", // Keeping it normal to preserve text wrapping
																					display: "block", // Changing to block to remove line clamp effect
																				}),
																				option: (base) => ({
																					...base,
																					overflow: "visible", // Adjusting to visible to show all content
																					textOverflow: "clip", // Adjusting to clip to avoid truncation
																					whiteSpace: "normal", // Keeping it normal to preserve text wrapping
																				}),
																				menuPortal: (base) => ({
																					...base,
																					zIndex: 9999, // Keeping zIndex to ensure it appears above other elements
																				}),
																			}}
																			theme={(theme) => ({
																				...theme,
																				borderRadius: 5,
																				colors: {
																					...theme.colors,
																					primary25: "lightgray",
																					primary: "black",
																				},
																			})}
																		/>
																	</div>
																	<div className="w-50%">
																		<label htmlFor="location" className="block text-sm font-medium leading-6 text-gray-900">
																			Salary
																		</label>
																		<Select
																			options={salaries}
																			value={selectedSalary}
																			name="salaries"
																			menuPortalTarget={document.body}
																			onChange={handleChangeSalary}
																			className="w-[170px]"
																			styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
																			theme={(theme) => ({
																				...theme,
																				borderRadius: 5,
																				colors: {
																					...theme.colors,
																					primary25: "lightgray",
																					primary: "black",
																				},
																			})}
																		/>
																	</div>
																</div>
															</div>
														</AccordionBody>
													</Accordion>
												</Fragment>
												<div className="flow-root">
													<div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
														<div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
															{loading ? (
																<>
																	<Skeleton height={20} />
																	<Skeleton height={40} />
																	<Skeleton className="mt-8" height={20} />
																	<Skeleton height={40} />
																	<Skeleton className="mt-8" height={20} />
																	<Skeleton height={40} />
																	<Skeleton className="mt-8" height={20} />
																	<Skeleton height={40} />
																</>
															) : (
																<table className="min-w-full divide-y divide-gray-300">
																	<thead>
																		<tr>
																			<th scope="col" className="py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-gray-900 sm:pl-0">
																				To Automate (Pay $0 for 6 Months!)
																				<div className="text-xs leading-5 text-gray-500 font-light">Describe what you need automated.</div>
																			</th>
																			<th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900 max-w-[100px]">
																				Hrs/Wk
																				<div className="text-xs leading-5 text-gray-500 font-light text-white">""</div>
																			</th>
																			<th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900">
																				$/Year
																				<div className="text-xs leading-5 text-gray-500 font-light text-white">""</div>
																			</th>
																			<th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900 max-w-[250px]">
																				eSavings
																				<div className="text-xs leading-5 text-gray-500 font-light">&lt; 30 days</div>
																			</th>
																			<th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-0 max-w-[100px]">
																				ePrice
																				<div className="text-xs leading-5 text-gray-500 font-light text-white">""</div>
																			</th>
																			<th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-0 max-w-[100px]">
																				Automate
																				<div className="text-xs leading-5 text-gray-500 font-light text-white">""</div>
																			</th>
																			<th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-0 max-w-[100px]">
																				<div className="text-xs leading-5 text-gray-500 font-light text-white">""</div>
																			</th>
																		</tr>
																	</thead>
																	<tbody className="divide-y divide-gray-200">
																		{/* https://stackoverflow.com/questions/69397935/how-to-properly-use-a-for-loop-in-getting-the-values-of-inputs-in-react-js */}
																		{newResponsibilities.map((person, i) => (
																			<>
																				<tr key={i}>
																					<td className="flex-wrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0 max-w-[350px]">
																						<Creatable
																							placeholder="Select a responsibility"
																							// options={newResponsibilities}
																							options={newResponsibilities}
																							defaultValue={newResponsibilities[i]}
																							value={newResponsibilities[i]}
																							onChange={(event, checked) => handleReactSelectChange(event, checked, i)}
																							// defaultValue={newResponsibilities[i]}
																							noOptionsMessage={() => "name not found"}
																							menuPortalTarget={document.body}
																							styles={{
																								menu: (base) => ({
																									...base,
																									maxHeight: "auto", // Adjusting to auto to fit content
																									overflowY: "visible", // Adjusting to visible to fit content
																								}),
																								singleValue: (base) => ({
																									...base,
																									overflow: "visible", // Adjusting to visible to show all content
																									maxHeight: "none", // Removing max-height restriction
																									textOverflow: "clip", // Adjusting to clip to avoid truncation
																									whiteSpace: "normal", // Keeping it normal to preserve text wrapping
																									display: "block", // Changing to block to remove line clamp effect
																								}),
																								option: (base) => ({
																									...base,
																									overflow: "visible", // Adjusting to visible to show all content
																									textOverflow: "clip", // Adjusting to clip to avoid truncation
																									whiteSpace: "normal", // Keeping it normal to preserve text wrapping
																								}),
																								menuPortal: (base) => ({
																									...base,
																									zIndex: 9999, // Keeping zIndex to ensure it appears above other elements
																								}),
																							}}
																						// components={{ MenuList: SelectMenuButton }}
																						></Creatable>
																					</td>
																					<td className="whitespace-nowrap px-3 py-4 text-sm text-center text-gray-500 max-w-[70px]">
																						<input
																							type="email"
																							name="email"
																							className="block w-4/5 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
																							placeholder="4"
																							key={i}
																							id={i}
																							value={inputData[i]}
																							onChange={handleChange}
																						/>
																					</td>
																					<td className="whitespace-nowrap px-3 py-4 text-sm text-gray-700">
																						{currencyFormat((inputData[i] * selected.fields.Salary) / 40)}/yr
																					</td>
																					<td className="whitespace-nowrap px-3 py-4 text-sm text-gray-700 text-center max-w-[100px] font-bold">
																						{currencyFormat((inputData[i] * selected.fields.Salary * 0.8) / 40)}/yr
																					</td>
																					<td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-center sm:pr-0">
																						{currencyFormat((inputData[i] * selected.fields.Salary * 0.2) / 40)}/yr
																					</td>
																					<td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-center font-medium sm:pr-0">
																						<Switch checked={toggleData[i].value} onChange={() => handleSwitch(i, toggleData[i].value)}>
																							{({ checked }) => (
																								<div
																									className={`${checked ? "bg-gray-700" : "bg-gray-200"}
																																								relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2`}
																								>
																									<span className="sr-only">Use setting</span>
																									<span
																										aria-hidden="true"
																										className={`${checked ? "translate-x-5" : "translate-x-0"
																											} pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`}
																									/>
																								</div>
																							)}
																						</Switch>
																					</td>
																					<td>
																						{editMode ? (
																							<button onClick={() => setEditMode(false)}>
																								<CheckIcon className='h-6 w-6' />
																							</button>
																						) : (
																							<button onClick={() => setEditMode(true)}>
																								<PencilIcon className='h-6 w-6' />
																							</button>
																						)}
																					</td>
																				</tr>
																				{/* <tr>
																		{automationUpgrades ? matchAutomations(newResponsibilities[i].value, automationUpgrades, 0.9).map(upgrade => upgrade.fields.Name).map((string, index) => (
																		<p key={index}>{string}</p>
																	)) : null}
																</tr> */}

																				{editMode && admin && (
																					<AutomationUpgrade
																						automationOptions={automationOptions}
																						responsibility={newResponsibilities[i]}
																						automationUpgrades={automationUpgrades}
																						name={selected.fields.Name}
																						biggerAutomationMap={biggerAutomationMap}
																						setBiggerAutomationMap={setBiggerAutomationMap}
																						newResponsibilities={newResponsibilities}
																						sendSoftwareSelectDataToParent={handleSoftwareSelectChange}
																						sendAutomationSelectDataToParent={handleAutomationSelectChange}
																						sendLoomDataToParent={handleLoomChange}
																					/>
																				)}
																			</>
																		))}
																	</tbody>
																</table>
															)}
														</div>
													</div>
												</div>
												{/* Saving responsibilities notification */}
												<Notification
													showNotif={reqSavingsNotif.showNotif}
													setShowNotif={(val) => setShowNotif(val, setReqSavingsNotif)}
													contents={reqSavingsNotif.contents}
												/>
											</div>
										</div>
									</div>
								</table>
							)}
						</div>
					)}
				</div>
			</div>

			{/* Mobile View */}
			{!hideTabBar && (
			<div className="md:hidden">
				<div id="automations"></div>
				<div className="sticky top-[105px] md:top-16 bg-white mx-auto w-full mb-20 z-10 p-4 pb-6" id="">
					<h1 className="text-2xl font-semibold leading-6 text-gray-900">Ai, Automations & Outsourcing</h1>
				</div>

				<div className={`${fullBlur && 'blurred overflow-hidden pointer-events-none'}`}>
					<Fragment>
						<Accordion open={totalOpen} icon={<Icon id={1} open={totalOpen} />}>
							<AccordionHeader onClick={() => setTotalOpen(!totalOpen)}></AccordionHeader>
							<AccordionBody>
								<div class="border-2 pt-4 border-black rounded-lg relative">
									<div className="pl-10">
										<button
											onClick={() => {
												setCurrentPage(!currentPage);
												fastScroll();
											}}
										>
											<ArrowsRightLeftIcon className="h-8 w-8" aria-hidden="true" />
										</button>
									</div>

									{currentPage ? (
										<div class="max-h-[630px] overflow-y-scroll" ref={scrollableDivRef}>
											<div>
												<div className="text-center">
													<svg
														className="mx-auto h-10 w-10 text-gray-400"
														fill="none"
														stroke="currentColor"
														viewBox="0 0 48 48"
														aria-hidden="true"
													>
														<path
															strokeLinecap="round"
															strokeLinejoin="round"
															strokeWidth={2}
															d="M34 40h10v-4a6 6 0 00-10.712-3.714M34 40H14m20 0v-4a9.971 9.971 0 00-.712-3.714M14 40H4v-4a6 6 0 0110.713-3.714M14 40v-4c0-1.313.253-2.566.713-3.714m0 0A10.003 10.003 0 0124 26c4.21 0 7.813 2.602 9.288 6.286M30 14a6 6 0 11-12 0 6 6 0 0112 0zm12 6a4 4 0 11-8 0 4 4 0 018 0zm-28 0a4 4 0 11-8 0 4 4 0 018 0z"
														/>
													</svg>
													<h2 className="mt-1 text-base font-semibold leading-6 text-gray-900">Add team members</h2>
												</div>
												<form className="space-y-6 px-4 -mt-2 pb-4" method="POST" onSubmit={addNewPeople}>
													<label htmlFor="email" className="sr-only">
														Email address
													</label>
													<input
														type="text"
														name="personLinkedInUrl"
														id="personLinkedInUrl"
														className="inline w-10/12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-900 sm:text-sm sm:leading-6"
														placeholder="Enter a personal linkedin url"
													/>
													<button
														type="submit"
														className="inline ml-1 flex-shrink-0 rounded-md bg-gray-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
													>
														Add
													</button>
												</form>
											</div>
											<RadioGroup
												value={selected}
												onChange={(value) => {
													setNewResp(value);
													setToggleData(JSON.parse(value.fields.DesiredUpgrades));
													setSelected(value);
													setSelectedOption({ value: value.fields.MatchedTitle, label: value.fields.MatchedTitle });
													setNewResponsibilities(JSON.parse(value.fields.Responsibilities));
													setInputData(JSON.parse(value.fields.Hours));
													debugLog("really selected", value);
												}}
											>
												<RadioGroup.Label className="sr-only">Server size</RadioGroup.Label>
												<div className="space-y-4 mx-4">
													{newPeople
														? newPeople
															.filter((person) => person?.fields?.Domain == company?.fields?.Domain)
															.map((plan) => (
																<RadioGroup.Option
																	key={JSON.stringify(plan)}
																	value={plan}
																	onClick={() => {
																		setCurrentPage(!currentPage);
																		fastScroll();
																	}}
																	className={({ checked, active }) =>
																		classNames(
																			checked ? "border-transparent" : "border-gray-300",
																			active ? "border-gray-800 ring-2 ring-gray-800" : "",
																			"relative block cursor-pointer rounded-lg border bg-white px-6 py-4 shadow-sm focus:outline-none sm:flex sm:justify-between"
																		)
																	}
																>
																	{({ active, checked }) => (
																		<>
																			<div className="flex items-center mx-2">
																				<div className="h-11 w-11 flex-shrink-0">
																					<img
																						className="h-11 w-11 rounded-full"
																						src={plan?.fields?.PictureUrlOrig ? plan?.fields?.PictureUrlOrig : company.fields.LogoUrl}
																						alt=""
																					/>
																				</div>
																				<div className="ml-4">
																					<div className="w-40 font-medium text-gray-900">{plan?.fields?.Name}</div>
																					<div className="w-40 mt-1 text-gray-500">{plan?.fields?.Title}</div>
																				</div>
																			</div>
																			<span
																				className={classNames(
																					active ? "border" : "border-2",
																					checked ? "border-indigo-600" : "border-transparent",
																					"pointer-events-none absolute -inset-px rounded-lg"
																				)}
																				aria-hidden="true"
																			/>
																			<button
																				class="absolute top-1/2 transform -translate-x-1/2 -translate-y-1/2 right-5 align-middle ml-8 text-gray-200 hover:text-black"
																				onClick={() => handleDeleteNewPeople(plan.id)}
																			>
																				<TrashIcon className="h-5 w-5 text-xl" aria-hidden="true" />
																			</button>
																		</>
																	)}
																</RadioGroup.Option>
															))
														: null}

													{people
														? people.map((plan) => (
															<RadioGroup.Option
																key={JSON.stringify(plan)}
																value={plan}
																onClick={() => {
																	setCurrentPage(!currentPage);
																	fastScroll();
																}}
																className={({ checked, active }) =>
																	classNames(
																		checked ? "border-transparent" : "border-gray-300",
																		active ? "border-gray-800 ring-2 ring-gray-800" : "",
																		"relative block cursor-pointer rounded-lg border bg-white px-6 py-4 shadow-sm focus:outline-none sm:flex sm:justify-between"
																	)
																}
															>
																{({ active, checked }) => (
																	<>
																		<div className="flex items-center mx-2">
																			<div className="h-11 w-11 flex-shrink-0">
																				<img
																					className="h-11 w-11 rounded-full"
																					src={plan.picture_url_orig ? plan.picture_url_orig : company.fields.LogoUrl}
																					alt=""
																				/>
																			</div>
																			<div className="ml-4">
																				<div className="font-medium text-gray-900">{plan.name}</div>
																				<div className="mt-1 text-gray-500">{plan.title}</div>
																			</div>
																		</div>
																		<span
																			className={classNames(
																				active ? "border" : "border-2",
																				checked ? "border-gray-600" : "border-transparent",
																				"pointer-events-none absolute -inset-px rounded-lg"
																			)}
																			aria-hidden="true"
																		/>
																		<button
																			class="absolute top-1/2 transform -translate-x-1/2 -translate-y-1/2 right-5 align-middle ml-8 text-gray-200 hover:text-black"
																			onClick={() => handleDeleteOldPeople(plan)}
																		>
																			<TrashIcon className="h-5 w-5 text-xl" aria-hidden="true" />
																		</button>
																	</>
																)}
															</RadioGroup.Option>
														))
														: null}
												</div>
											</RadioGroup>
										</div>
									) : (
										<div class="pl-10 pt-10 pb-2 max-h-[630px] overflow-y-scroll overflow-x-scroll" ref={scrollableDivRef}>
											<div className="bg-white">
												<div className="-mt-4 flex sm:flex-nowrap">
													<div className="">
														<img
															className="h-10 w-10 rounded-full"
															src={
																selected?.fields?.PictureUrlOrig
																	? selected.fields.PictureUrlOrig
																	: selected?.fields?.PictureUrlCopy
																		? selected.fields.PictureUrlCopy
																		: company.fields.LogoUrl
															}
															alt=""
														/>
													</div>
													<div className="text-left w-9/12">
														<h4 className="ml-4 text-base font-semibold leading-6 text-gray-900">
															{selected?.fields?.Name && selected?.fields?.Name.length > 60
																? selected.fields.Name.substring(0, 60) + ".."
																: selected?.fields?.Name
																	? selected.fields.Name
																	: "Add a new person to get started!"}
															<br />
															{selected?.fields?.Title && selected?.fields?.Title.length > 60
																? selected.fields.Title.substring(0, 60) + ".."
																: selected?.fields?.Title
																	? selected.fields.Title + ", "
																	: null}
															{selected?.fields?.Name && selected.fields.Salary !== 0 ? currencyFormat(selected.fields.Salary) + "/yr" : null}
														</h4>
														<p className="ml-4 mt-1 text-sm text-gray-500 font-light">
															Responsibilities & upgraded savings working{" "}
															{selected?.fields?.Name && selected.fields.Salary !== 0
																? Object.values(inputData).reduce((acc, c) => {
																	return acc + +c;
																}, 0)
																: "0"}{" "}
															hrs per wk
														</p>
													</div>
												</div>
												<button
													class="mt-4 box-border h-12 relative z-10 inline-flex items-center justify-center w-auto px-4 py-2 overflow-hidden font-bold text-white transition-all duration-300 bg-gray-900 rounded-md cursor-pointer group ring-offset-2 ring-1 ring-gray-300 ring-offset-gray-200 hover:ring-offset-gray-500 ease focus:outline-none"
													onClick={handleSave}
												>
													<span class="absolute bottom-0 right-0 w-8 h-20 -mb-8 -mr-5 transition-all duration-300 ease-out transform rotate-45 translate-x-1 bg-white opacity-10 group-hover:translate-x-0" />
													<span class="absolute top-0 left-0 w-20 h-8 -mt-1 -ml-12 transition-all duration-300 ease-out transform -rotate-45 -translate-x-1 bg-white opacity-10 group-hover:translate-x-0" />
													<span class="relative flex items-center text-sm">Save</span>
												</button>
												<button
													class="ml-2 box-border h-12 relative z-10 inline-flex items-center justify-center w-auto px-4 py-2 overflow-hidden font-bold text-white transition-all duration-300 bg-gray-900 rounded-md cursor-pointer group ring-offset-2 ring-1 ring-gray-300 ring-offset-gray-200 hover:ring-offset-gray-500 ease focus:outline-none"
													onClick={handleRequest}
												>
													<span class="absolute bottom-0 right-0 w-8 h-20 -mb-8 -mr-5 transition-all duration-300 ease-out transform rotate-45 translate-x-1 bg-white opacity-10 group-hover:translate-x-0" />
													<span class="absolute top-0 left-0 w-20 h-8 -mt-1 -ml-12 transition-all duration-300 ease-out transform -rotate-45 -translate-x-1 bg-white opacity-10 group-hover:translate-x-0" />
													<span class="relative flex items-center text-sm">Request Ai Automations</span>
												</button>
												<Switch
													checked={enabled}
													onChange={(checked) => {
														setEnabled(checked);
														debugLog("enabled", enabled);
													}}
													className="group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-gray-600 focus:ring-offset-2 data-[checked]:bg-gray-600"
												>
													<span
														aria-hidden="true"
														className="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
													/>
												</Switch>
											</div>
											<Fragment>
												<Accordion accordion open={open} icon={<></>}>
													<AccordionHeader onClick={() => setOpen(!open)}>
														<Icon id={1} open={open} />
													</AccordionHeader>

													<AccordionBody>
														<div className="border-b border-gray-200 bg-white px-4 py-5 sm:px-6">
															<div className="w-full">
																{/* { selected.fields.Responsibilities }
																											<br />
																											<br />
																											<br />
																									{ JSON.stringify(newResponsibilities) } */}
															</div>
															<div className="-ml-4 -mt-6 flex flex-wrap items-center justify-between sm:flex-nowrap">
																<div className="w-50%">
																	<label htmlFor="location" className="block text-sm font-medium leading-6 text-gray-900">
																		Title
																	</label>
																	<Select
																		options={titles}
																		value={selectedOption}
																		onChange={handleChangeTitle}
																		name="titles"
																		menuPortalTarget={document.body}
																		className="w-[270px]"
																		styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
																		theme={(theme) => ({
																			...theme,
																			borderRadius: 5,
																			colors: {
																				...theme.colors,
																				primary25: "lightgray",
																				primary: "black",
																			},
																		})}
																	/>
																</div>
																<div className="w-50%">
																	<label htmlFor="location" className="block text-sm font-medium leading-6 text-gray-900">
																		Salary
																	</label>
																	<Select
																		options={salaries}
																		value={selectedSalary}
																		name="salaries"
																		menuPortalTarget={document.body}
																		onChange={handleChangeSalary}
																		className="w-[170px]"
																		styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
																		theme={(theme) => ({
																			...theme,
																			borderRadius: 5,
																			colors: {
																				...theme.colors,
																				primary25: "lightgray",
																				primary: "black",
																			},
																		})}
																	/>
																</div>
															</div>
														</div>
													</AccordionBody>
												</Accordion>
											</Fragment>
											<div className="pr-5">
												<div className="">
													<div className="-mt-8 py-2">
														{loading ? (
															<>
																<Skeleton height={20} />
																<Skeleton height={40} />
																<Skeleton className="mt-8" height={20} />
																<Skeleton height={40} />
																<Skeleton className="mt-8" height={20} />
																<Skeleton height={40} />
																<Skeleton className="mt-8" height={20} />
																<Skeleton height={40} />
																<Skeleton className="mt-8" height={20} />
																<Skeleton height={40} />
																<Skeleton className="mt-8" height={20} />
																<Skeleton height={40} />
															</>
														) : (
															<>
																<h1 className="text-center mt-4 max-w-lg text-2xl font-bold tracking-tight text-gray-900">
																	Upgrades For Your Responsibilities
																</h1>
																{/* https://stackoverflow.com/questions/69397935/how-to-properly-use-a-for-loop-in-getting-the-values-of-inputs-in-react-js */}
																{newResponsibilities.map((person, i) => (
																	<>
																		<div class="relative bg-white border-2 mx-auto py-6 px-6 rounded-3xl mt-8 mb-12 shadow-xl">
																			<div class=" text-white flex items-center absolute rounded-full py-4 px-4 shadow-xl bg-blue-500 left-4 -top-6">
																				<svg
																					xmlns="http://www.w3.org/2000/svg"
																					class="h-8 w-8"
																					fill="none"
																					viewBox="0 0 24 24"
																					stroke="currentColor"
																				>
																					<path
																						strokeLinecap="round"
																						strokeLinejoin="round"
																						strokeWidth="2"
																						d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
																					/>
																				</svg>
																			</div>
																			<div class="mt-10">
																				<div className="my-6 text-xl font-semibold tracking-tight text-gray-900">
																					<div className="block mb-1 leading-6">
																						Currently Spending{" "}
																						<span class="text-red-600">
																							{currencyFormat((inputData[i] * selected.fields.Salary) / 40)}/yr
																						</span>
																					</div>
																					<div className="block mb-1 leading-6">
																						Save{" "}
																						<span class="text-blue-600">
																							{currencyFormat((inputData[i] * selected.fields.Salary * 0.8) / 40)}/yr (80%)
																						</span>
																					</div>
																					<div className="block leading-6">
																						Price{" "}
																						<span class="text-gray-600">
																							{currencyFormat((inputData[i] * selected.fields.Salary * 0.2) / 40)}/yr
																						</span>
																					</div>
																				</div>
																				{/* <p class="text-xl font-semibold my-2"></p> */}
																				<div class="flex space-x-2 text-gray-400 text-sm">
																					<span className="text-lg mr-2 my-auto">💼</span>
																					<div>
																						<label className="block text-sm font-medium leading-6 text-gray-900">Responsibilities</label>
																						<Creatable
																							placeholder="Select a responsibility"
																							// options={newResponsibilities}
																							options={newResponsibilities}
																							// defaultValue={newResponsibilities[i]}
																							value={newResponsibilities[i]}
																							onChange={(event, checked) => handleReactSelectChange(event, checked, i)}
																							noOptionsMessage={() => "name not found"}
																							menuPortalTarget={document.body}
																							styles={{
																								menu: (base) => ({
																									...base,
																									// adjust the value as necessary
																									maxHeight: 200,
																									overflowY: "auto", // add this if you have many options
																								}),
																								singleValue: (base) => ({
																									...base,
																									overflow: "hidden",
																									maxHeight: 60,
																									textOverflow: "ellipsis",
																									whiteSpace: "normal",
																									display: "-webkit-box",
																									WebkitLineClamp: "3",
																									WebkitBoxOrient: "vertical",
																								}),
																								option: (base) => ({
																									...base,
																									overflow: "visible",
																									textOverflow: "clip",
																									whiteSpace: "normal",
																								}),
																								menuPortal: (base) => ({
																									...base,
																									zIndex: 9999,
																								}),
																							}}
																							theme={(theme) => ({
																								...theme,
																								borderRadius: 10,
																								colors: {
																									...theme.colors,
																									primary25: "lightgray",
																									primary: "black",
																								},
																							})}
																						// components={{ MenuList: SelectMenuButton }}
																						></Creatable>
																					</div>
																				</div>

																				<div class="flex space-x-2 text-gray-400 text-sm my-3">
																					<span className="text-lg mr-2 my-auto">⏱️</span>
																					<div>
																						<label className="block text-sm font-medium leading-6 text-gray-900">Hours/Week</label>
																						<input
																							type="email"
																							name="email"
																							className="block rounded-md w-24 border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-600 sm:text-sm sm:leading-6"
																							placeholder="4"
																							key={i}
																							id={i}
																							value={inputData[i]}
																							onChange={handleChange}
																						/>
																					</div>
																				</div>
																				<div class="border-t-2"></div>

																				<div class="flex justify-between">
																					<div class="my-2">
																						<p class="font-semibold text-base mb-2">Delivery Partners</p>
																						<div class="flex space-x-2">
																							<div className="-space-x-1 overflow-hidden">
																								{grantWriters?.slice(Math.random(), 5 + Math.random()).map((grantwriter) => (
																									<img
																										className="inline-block h-6 w-6 rounded-full ring-2 ring-white"
																										src={grantwriter.fields.PictureUrlCopy}
																										alt=""
																									/>
																								))}
																							</div>
																						</div>
																					</div>
																					<div class="my-2">
																						<p class="font-semibold text-base mb-2">Upgrade</p>
																						<div class="ml-3 text-base text-gray-400 font-semibold">
																							<Switch checked={toggleData[i].value} onChange={() => handleSwitch(i, toggleData[i].value)}>
																								{({ checked }) => (
																									<div
																										className={`${checked ? "bg-gray-700" : "bg-gray-200"}
																																															relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2`}
																									>
																										<span className="sr-only">Use setting</span>
																										<span
																											aria-hidden="true"
																											className={`${checked ? "translate-x-5" : "translate-x-0"
																												} pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`}
																										/>
																									</div>
																								)}
																							</Switch>
																						</div>
																					</div>
																				</div>
																			</div>
																		</div>

																		{/* <div className='border-2 rounded-lg mt-10' key={person.name}>
																																	<div className="flex-wrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900">
																																			<div className="relative whitespace-nowrap py-4 pl-3 text-right font-medium">
																																					<Switch
																																							checked={toggleData[i].value}
																																							onChange={() => handleSwitch(i, toggleData[i].value)}
																																					>
																																							{({ checked }) => (
																																									<div
																																									className={`${
																																											checked ? 'bg-gray-700' : 'bg-gray-200'
																																									}
																																											relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2`
																																									}
																																									>
																																									<span className="sr-only">Use setting</span>
																																									<span
																																											aria-hidden="true"
																																											className={`${
																																													checked ? 'translate-x-5' : 'translate-x-0'
																																											} pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`
																																											}
																																									/>
																																									</div>
																																							
																																							)}
																																					</Switch>
																																			</div>
																																			<hr/>
																																			<div class='mt-4'>
																																					<label
																																							className="block text-sm font-medium leading-6 text-gray-900"
																																					>
																																							Responsibility
																																					</label>
																																					<Creatable
																																							placeholder="Select a responsibility"
																																							// options={newResponsibilities}
																																							options={newResponsibilities}
																																							// defaultValue={newResponsibilities[i]}
																																							value={newResponsibilities[i]}
																																							onChange={(event, checked) => handleReactSelectChange(event, checked, i)}
																																							noOptionsMessage={() => "name not found"}
																																							menuPortalTarget={document.body}
																																							styles={{
																																									menu: (base) => ({
																																									...base,
																																									// adjust the value as necessary
																																									maxHeight: 200,
																																									overflowY: 'auto', // add this if you have many options
																																									}),
																																									singleValue: (base) => ({
																																											...base,
																																											overflow: 'hidden',
																																											maxHeight: 60,
																																											textOverflow: 'ellipsis',
																																											whiteSpace: 'normal',
																																											display: '-webkit-box',
																																											WebkitLineClamp: '3',
																																											WebkitBoxOrient: 'vertical',
																																									}),
																																									option: (base) => ({
																																									...base,
																																									overflow: 'visible',
																																									textOverflow: 'clip',
																																									whiteSpace: 'normal'
																																									}),
																																									menuPortal: base => ({
																																									...base,
																																									zIndex: 9999
																																									})
																																							}}
																																							theme={(theme) => ({
																																									...theme,
																																									borderRadius: 5,
																																									colors: {
																																											...theme.colors,
																																											primary25: 'lightgray',
																																											primary: 'black',
																																									},
																																							})}
																																					// components={{ MenuList: SelectMenuButton }}
																																					></Creatable>
																																			</div>
																																			<div className="whitespace-nowrap mt-4 text-sm  text-gray-500 max-w-[70px]">
																																					<label
																																							className="block text-sm font-medium leading-6 text-gray-900"
																																					>
																																							Hours
																																					</label>
																																					<input
																																							type="email"
																																							name="email"
																																							className="block w-4/5 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
																																							placeholder="4"
																																							key={i}
																																							id={i}
																																							value={inputData[i]}
																																							onChange={handleChange}
																																					/>
																				</div>

																				<div className="mx-auto mt-6 text-sm text-center w-9/12">
																						<div
																								className="block text-sm font-medium leading-6 text-gray-900"
																		>
																								Spend <span class='text-red-600'>{currencyFormat(inputData[i] * selected.fields.Salary / 40)}/yr</span>
																		</div>
																</div>

																<div className="mx-auto mt-2 text-sm text-center w-9/12">
																		<div
																				className="block text-sm font-medium leading-6 text-gray-900"
																		>
																				Save <span class='text-blue-600'>{currencyFormat(inputData[i] * selected.fields.Salary * 0.8 / 40)}/yr (80%)</span>
																		</div>
																</div>

																<div className="mx-auto mt-2 text-sm text-center w-9/12">
																		<div
																				className="block text-sm font-medium leading-6 text-gray-900"
																		>
																				Price <span class='text-gray-600'>{currencyFormat(inputData[i] * selected.fields.Salary * 0.2 / 40)}/yr</span>
																		</div>
																</div>

																																			
																</div>

																															</div> */}
																	</>
																))}
															</>
														)}
													</div>
												</div>
											</div>
											{/* Saving responsibilities notification */}
											<Notification
												showNotif={reqSavingsNotif.showNotif}
												setShowNotif={(val) => setShowNotif(val, setReqSavingsNotif)}
												contents={reqSavingsNotif.contents}
											/>
										</div>
									)}

									<div className="mt-1 pl-6 pb-2">
										<button className="" onClick={scrollToTop}>
											<ArrowUpIcon className="inline h-10 w-10 text-black" aria-hidden="true" />
											Up
										</button>
									</div>
								</div>
							</AccordionBody>
						</Accordion>
					</Fragment>
				</div>


			</div>
			)}
		</>
	);
}
